import React, { useState, useEffect, useRef, useMemo, useCallback } from "react";
import { useParams, useNavigate, useLocation, useSearchParams } from 'react-router-dom';
import './styleMobile.css'
import ModalConfirmInfoCliente from "../../components/ModalConfirmInfoCliente";
import ModalPaymentCash from "../../components/ModalPaymentCash";
import ModalPaymentPix from "../../components/ModalPaymentPix";
import ModalPaymentCard from "../../components/ModalPaymentCard";
import PhoneInput from "../../components/PhoneInput";
import { fromE164, formatPhoneDisplay } from '../../utils/phone';
import meuPdfPoliticaPrivacy from '../../assets/img/politica_privacidade.pdf';
import { deleteEnderecoClientePublic, registerClientePublic, registerPedido, calcularDistanciaSafe, getTunaConfigPublic, cancelExpiredOrder, finalizarCarrinho, atualizarPassoCarrinho } from "../../services/api";
import { toast } from "react-toastify";
import { FcClock } from "react-icons/fc";
import { FaPix } from "react-icons/fa6";
import { FaCreditCard } from "react-icons/fa";
import Loading from "react-loading";
import ToastWithLink from './ToastWithLink';  // Ajuste o caminho conforme necessário
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import { formatPriceWithSymbol } from '../../utils/currency';
import Money from '../../components/Money';

const FinalizarPedido = () => {
    const { t } = useTranslation('cardapio');
    const location = useLocation();
    const { nomeEmpresaForUrl, idEmpresa: idEmpresaParam, slug } = useParams();
    const identifier = slug || idEmpresaParam;
    const isSlugRoute = !!slug;

    // 🔧 FIX: Memoizar buildUrl com fallback para sessionStorage
    const buildUrl = useCallback((subpath) => {
        if (isSlugRoute && slug) {
            return `/c/${slug}/${subpath}`;
        } else if (nomeEmpresaForUrl && idEmpresaParam) {
            return `/cardapio/${nomeEmpresaForUrl}/${idEmpresaParam}/${subpath}`;
        }
        // Fallback: buscar do sessionStorage
        try {
            const empresaData = sessionStorage.getItem('sessionCompany');
            if (empresaData) {
                const parsed = JSON.parse(empresaData);
                if (parsed?.slug) {
                    return `/c/${parsed.slug}/${subpath}`;
                } else if (parsed?.name && parsed?.id_empresa) {
                    const nomeForUrl = parsed.name.toLowerCase().replace(/\s+/g, '-');
                    return `/cardapio/${nomeForUrl}/${parsed.id_empresa}/${subpath}`;
                }
            }
        } catch (e) {
            console.error('[FINALIZAR] Erro ao construir URL:', e);
        }
        // Último fallback
        console.warn('[FINALIZAR] buildUrl: Não foi possível construir URL válida para:', subpath);
        return `/cardapio/${nomeEmpresaForUrl}/${idEmpresaParam}/${subpath}`;
    }, [isSlugRoute, slug, nomeEmpresaForUrl, idEmpresaParam]);

    // 🔒 Leitura segura do localStorage com validação
    const getLocalPersonInfo = () => {
        try {
            const stored = localStorage.getItem('localPersonInfo');
            if (stored) {
                const parsed = JSON.parse(stored);
                // Verificar se tem estrutura mínima válida
                if (parsed && typeof parsed === 'object') {
                    return parsed;
                }
            }
        } catch (error) {
            process.env.REACT_APP_ISDEVELOP === 'true' && console.error('Erro ao parsear localPersonInfo:', error);
            localStorage.removeItem('localPersonInfo'); // Limpar dados corrompidos
        }
        return null;
    };
    
    const localPersonInfo = getLocalPersonInfo();
    var { personInfoObj } = location.state || {};
    
    // 🎯 Verificar se há endereço para seleção automática
    process.env.REACT_APP_ISDEVELOP === 'true' && console.log("📋 PersonInfoObj recebido:", personInfoObj);
    const [valorTroco, setValorTroco] = useState(0);

    // 🔧 FIX: Usar useState para empresa para permitir atualizações quando sessionStorage mudar
    const [empresa, setEmpresa] = useState(() => {
        try {
            const raw = sessionStorage.getItem('sessionCompany');
            return raw ? JSON.parse(raw) : null;
        } catch { return null; }
    });

    // 🔧 FIX: Atualizar empresa quando sessionStorage for modificado (ou quando montar sem dados)
    useEffect(() => {
        // Se empresa já existe, não precisa atualizar
        if (empresa?.id_empresa) return;

        // Tentar carregar do sessionStorage novamente (pode ter sido preenchido após montagem inicial)
        const checkSessionStorage = () => {
            try {
                const raw = sessionStorage.getItem('sessionCompany');
                if (raw) {
                    const parsed = JSON.parse(raw);
                    if (parsed?.id_empresa && !empresa?.id_empresa) {
                        console.log('🔄 [FINALIZAR] Empresa carregada do sessionStorage:', parsed.id_empresa);
                        setEmpresa(parsed);
                    }
                }
            } catch (e) {
                console.error('Erro ao ler sessionStorage:', e);
            }
        };

        // Checar imediatamente
        checkSessionStorage();

        // E também em um intervalo curto para garantir (caso sessionStorage seja preenchido logo após)
        const intervalId = setInterval(checkSessionStorage, 500);

        // Limpar após 3 segundos (sessionStorage já deveria estar preenchido)
        const timeoutId = setTimeout(() => clearInterval(intervalId), 3000);

        return () => {
            clearInterval(intervalId);
            clearTimeout(timeoutId);
        };
    }, [empresa?.id_empresa]);

    // 🔧 FIX: Usar id_empresa do sessionStorage quando não disponível na URL (rota slug)
    const idEmpresa = idEmpresaParam || empresa?.id_empresa;

    const regionType = empresa?.region_type_delivery;
    const bairros_entrega = empresa?.bairros_entrega;
    //const stateFromItemModal = location.state;
    //var fromItemAddModal = false;
    //if(stateFromItemModal !== null){
    //    fromItemAddModal = location.state.fromItemAddModal;
    //} 

    // Obtém o external_id da URL atual, se existir
    const [searchParams] = useSearchParams();
    const externalId = searchParams.get('external_id');

    const [isLoading, setIsLoading] = useState(false);
    const [loadingMessage, setLoadingMessage] = useState("");

    const navigate = useNavigate();

    // 🔧 FIX: buildUrlSafe memoizado com fallback para sessionStorage
    const buildUrlSafe = useCallback((subpath) => {
        if (isSlugRoute && slug) {
            return `/c/${slug}/${subpath}`;
        } else if (nomeEmpresaForUrl && idEmpresa) {
            return `/cardapio/${nomeEmpresaForUrl}/${idEmpresa}/${subpath}`;
        } else if (empresa?.slug) {
            return `/c/${empresa.slug}/${subpath}`;
        } else if (empresa?.name && empresa?.id_empresa) {
            const nomeForUrl = empresa.name.toLowerCase().replace(/\s+/g, '-');
            return `/cardapio/${nomeForUrl}/${empresa.id_empresa}/${subpath}`;
        }
        return null;
    }, [isSlugRoute, slug, nomeEmpresaForUrl, idEmpresa, empresa]);

    const handleBack = () => {
        const url = buildUrlSafe('carrinho');
        if (url) {
            navigate(externalId ? `${url}?external_id=${externalId}` : url);
        } else {
            console.warn('[FINALIZAR] Usando history.back() como fallback');
            navigate(-1);
        }
    }

    const enderecoEmpresa = useMemo(() => ({
        rua: empresa?.logradouro,
        numero: empresa?.address_number,
        bairro: empresa?.bairro,
        cidade: empresa?.municipio,
        estado: empresa?.estado
    }), [empresa?.logradouro, empresa?.address_number, empresa?.bairro, empresa?.municipio, empresa?.estado]);

    //const [itensCarrinho, setItensCarrinho] = useState([]);
    const [carrinho, setCarrinho] = useState([]);
    const [showConfirmInfo, setShowConfirmInfo] = useState(false);
    //const [infoPersonalData, setInfoPersonalData] = useState(false);
    const [whatsappData, setWhatsappData] = useState(localPersonInfo ? localPersonInfo.telefone : "");
    const [namePersonData, setNamePersonData] = useState(localPersonInfo ? localPersonInfo.nome : "");
    //const [idEmpresa, setIdEmpresa] = useState("");
    const [clientCompleteData, setClientCompleteData] = useState(personInfoObj ? personInfoObj : "");
    const [selectedAddressToDelivery, setSelectedAddressToDelivery] = useState("");
    const [selectedAddressToRetirada, setSelectedAddressToRetirada] = useState("");
    const [paymentType, setPaymentType] = useState("");
    const [showModalPaymentCash, setShowModalPaymentCash] = useState(false);
    const [valorEntrega, setValorEntrega] = useState(0);
    const [calculandoDistancia, setCalculandoDistancia] = useState(false);

    // ✅ Estados Tuna Payments
    const [tunaEnabled, setTunaEnabled] = useState(false);
    const [tunaConfig, setTunaConfig] = useState(null);
    const [showPixModal, setShowPixModal] = useState(false);
    const [showCardModal, setShowCardModal] = useState(false);
    const [pendingPedidoId, setPendingPedidoId] = useState(null);

    // ✅ Estado para transação PIX pendente (quando usuário fechou modal sem pagar)
    const [hasExistingPixTransaction, setHasExistingPixTransaction] = useState(false);
    const existingPixPedidoIdRef = useRef(null);
    const existingPixValorRef = useRef(null); // ✅ NOVO: Guardar valor para detectar mudanças

    // ✅ Estado para pedido pendente de CARTÃO (quando usuário tem pedido aguardando pagamento)
    const [hasExistingCardPedido, setHasExistingCardPedido] = useState(false);
    const existingCardPedidoRef = useRef(null);

    // ✅ Função para verificar se existe transação PIX pendente no localStorage
    // IMPORTANTE: Agora também verifica se o valor mudou
    const checkExistingPixTransaction = useCallback((pedidoId, valorAtual = null) => {
        try {
            const storageKey = `pix_transaction_${pedidoId}`;
            const stored = localStorage.getItem(storageKey);
            if (stored) {
                const data = JSON.parse(stored);
                const expDate = new Date(data.expirationDate);

                // ✅ VERIFICAR SE EXPIROU
                if (expDate <= new Date()) {
                    console.log('[FINALIZAR] ⏰ Transação PIX expirada, cancelando no backend...');

                    if (idEmpresa && pedidoId) {
                        cancelExpiredOrder(
                            pedidoId,
                            idEmpresa,
                            t('checkout.pixPaymentExpired')
                        ).then(result => {
                            if (result.success) {
                                console.log('[FINALIZAR] ✅ Pedido PIX expirado cancelado no backend:', pedidoId);
                            } else {
                                console.log('[FINALIZAR] ⚠️ Não foi possível cancelar pedido PIX expirado:', result.msg || result.error);
                            }
                        }).catch(err => {
                            console.error('[FINALIZAR] Erro ao cancelar pedido PIX expirado:', err);
                        });
                    }

                    localStorage.removeItem(storageKey);
                    return false;
                }

                // ✅ VERIFICAR SE VALOR MUDOU (carrinho/entrega alterados)
                if (valorAtual !== null && data.amount) {
                    const valorSalvo = parseFloat(data.amount);
                    const valorAtualFloat = parseFloat(valorAtual);

                    // Tolerância de R$0.01 para evitar problemas de arredondamento
                    if (Math.abs(valorSalvo - valorAtualFloat) > 0.01) {
                        console.log(`[FINALIZAR] ⚠️ PIX - VALOR ALTERADO! Salvo: ${formatPriceWithSymbol(valorSalvo)}, Atual: ${formatPriceWithSymbol(valorAtualFloat)}`);
                        console.log('[FINALIZAR] 🗑️ Cancelando pedido PIX antigo pois carrinho/entrega foi alterado...');

                        if (idEmpresa && pedidoId) {
                            cancelExpiredOrder(
                                pedidoId,
                                idEmpresa,
                                `Carrinho alterado - valor mudou de ${formatPriceWithSymbol(valorSalvo)} para ${formatPriceWithSymbol(valorAtualFloat)}`,
                                true // force=true - mudança de valor, não expiração
                            ).then(result => {
                                if (result.success) {
                                    console.log('[FINALIZAR] ✅ Pedido PIX com valor desatualizado cancelado:', pedidoId);
                                    localStorage.removeItem(storageKey);
                                } else if (result.payment_confirmed) {
                                    // ✅ PROTEÇÃO: Pagamento já foi confirmado! Manter pedido original
                                    console.log('[FINALIZAR] 🛡️ Pagamento PIX já confirmado! Mantendo pedido original:', pedidoId);
                                    toast.info(t('pixAlreadyConfirmed', { amount: formatPriceWithSymbol(result.valor_pago || valorSalvo) }), {
                                        autoClose: 5000
                                    });
                                    // Não limpar localStorage - pedido ainda é válido
                                } else {
                                    console.log('[FINALIZAR] ⚠️ Não foi possível cancelar pedido PIX:', result.msg || result.error);
                                    localStorage.removeItem(storageKey);
                                }
                            }).catch(err => {
                                console.error('[FINALIZAR] Erro ao cancelar pedido PIX:', err);
                                // Em caso de erro, limpar localStorage para evitar estado inconsistente
                                localStorage.removeItem(storageKey);
                            });
                        } else {
                            localStorage.removeItem(storageKey);
                        }

                        return false;
                    }
                }

                // ✅ TRANSAÇÃO VÁLIDA: Mesmo valor e não expirou
                console.log('[FINALIZAR] ♻️ Transação PIX existente encontrada para pedido:', pedidoId);
                return true;
            }
        } catch (error) {
            console.error('[FINALIZAR] Erro ao verificar transação PIX:', error);
        }
        return false;
    }, [idEmpresa]);

    // ✅ Função para abrir modal PIX com transação existente
    const handleOpenExistingPixPayment = useCallback(() => {
        if (existingPixPedidoIdRef.current) {
            console.log('[FINALIZAR] 📲 Abrindo modal PIX para transação existente:', existingPixPedidoIdRef.current);
            setPendingPedidoId(existingPixPedidoIdRef.current);
            setShowPixModal(true);
        }
    }, []);

    // ✅ Função para verificar se existe pedido CARTÃO pendente no localStorage
    // SEGURANÇA: Mesma abordagem do PIX - apenas IDs no localStorage, sem dados sensíveis
    // IMPORTANTE: Agora recebe valorAtual para detectar mudanças no carrinho/entrega
    const checkExistingCardOrder = useCallback(async (valorAtual = null) => {
        try {
            if (!idEmpresa) return false;

            const storageKey = `card_order_${idEmpresa}`;
            const stored = localStorage.getItem(storageKey);

            if (stored) {
                const data = JSON.parse(stored);
                const expDate = new Date(data.expirationDate);

                // ✅ VERIFICAR SE EXPIROU
                if (expDate <= new Date()) {
                    console.log('[FINALIZAR] ⏰ Pedido CartaoOnline expirado, cancelando no backend...');

                    cancelExpiredOrder(
                        data.pedidoId,
                        idEmpresa,
                        t('checkout.cardPaymentExpired')
                    ).then(result => {
                        if (result.success) {
                            console.log('[FINALIZAR] ✅ Pedido expirado cancelado no backend:', data.pedidoId);
                        } else {
                            console.log('[FINALIZAR] ⚠️ Não foi possível cancelar pedido expirado:', result.msg || result.error);
                        }
                    }).catch(err => {
                        console.error('[FINALIZAR] Erro ao cancelar pedido expirado:', err);
                    });

                    localStorage.removeItem(storageKey);
                    existingCardPedidoRef.current = null;
                    setHasExistingCardPedido(false);
                    return false;
                }

                // ✅ VERIFICAR SE VALOR MUDOU (carrinho/entrega alterados)
                if (valorAtual !== null) {
                    const valorSalvo = parseFloat(data.valor_total);
                    const valorAtualFloat = parseFloat(valorAtual);

                    // Tolerância de R$0.01 para evitar problemas de arredondamento
                    if (Math.abs(valorSalvo - valorAtualFloat) > 0.01) {
                        console.log(`[FINALIZAR] ⚠️ VALOR ALTERADO! Salvo: ${formatPriceWithSymbol(valorSalvo)}, Atual: ${formatPriceWithSymbol(valorAtualFloat)}`);
                        console.log('[FINALIZAR] 🗑️ Cancelando pedido antigo pois carrinho/entrega foi alterado...');

                        cancelExpiredOrder(
                            data.pedidoId,
                            idEmpresa,
                            `Carrinho alterado - valor mudou de ${formatPriceWithSymbol(valorSalvo)} para ${formatPriceWithSymbol(valorAtualFloat)}`,
                            true // force=true - mudança de valor, não expiração
                        ).then(result => {
                            if (result.success) {
                                console.log('[FINALIZAR] ✅ Pedido com valor desatualizado cancelado:', data.pedidoId);
                                localStorage.removeItem(storageKey);
                                existingCardPedidoRef.current = null;
                                setHasExistingCardPedido(false);
                            } else if (result.payment_confirmed) {
                                // ✅ PROTEÇÃO: Pagamento já foi confirmado! Manter pedido original
                                console.log('[FINALIZAR] 🛡️ Pagamento CARTÃO já confirmado! Mantendo pedido original:', data.pedidoId);
                                toast.info(t('paymentAlreadyConfirmed', { amount: formatPriceWithSymbol(result.valor_pago || valorSalvo) }), {
                                    autoClose: 5000
                                });
                                // Não limpar localStorage - pedido ainda é válido
                            } else {
                                console.log('[FINALIZAR] ⚠️ Não foi possível cancelar pedido:', result.msg || result.error);
                                localStorage.removeItem(storageKey);
                                existingCardPedidoRef.current = null;
                                setHasExistingCardPedido(false);
                            }
                        }).catch(err => {
                            console.error('[FINALIZAR] Erro ao cancelar pedido:', err);
                            // Em caso de erro, limpar localStorage para evitar estado inconsistente
                            localStorage.removeItem(storageKey);
                            existingCardPedidoRef.current = null;
                            setHasExistingCardPedido(false);
                        });

                        return false;
                    }
                }

                // ✅ PEDIDO VÁLIDO: Mesmo valor e não expirou
                console.log('[FINALIZAR] 💳 Pedido CartaoOnline pendente encontrado no localStorage:', data.pedidoId);
                existingCardPedidoRef.current = {
                    _id: data.pedidoId,
                    valor_total: data.valor_total,
                    createdAt: data.createdAt
                };
                setHasExistingCardPedido(true);
                return true;
            }

            existingCardPedidoRef.current = null;
            setHasExistingCardPedido(false);
            return false;
        } catch (error) {
            console.error('[FINALIZAR] Erro ao verificar pedido cartão pendente:', error);
            return false;
        }
    }, [idEmpresa]);

    // ✅ Função para salvar pedido CARTÃO no localStorage (após criar pedido)
    // IMPORTANTE: Também atualiza state e ref para detecção imediata do pedido pendente
    const saveCardOrderToStorage = useCallback((pedidoId, valorTotal) => {
        try {
            if (!idEmpresa || !pedidoId) return;

            const storageKey = `card_order_${idEmpresa}`;
            const expirationDate = new Date(Date.now() + 30 * 60 * 1000); // 30 minutos (cartão não tem expire da Tuna)
            const createdAt = new Date().toISOString();

            const data = {
                pedidoId,
                valor_total: valorTotal,
                createdAt,
                expirationDate: expirationDate.toISOString()
            };

            localStorage.setItem(storageKey, JSON.stringify(data));
            console.log('[FINALIZAR] 💾 Pedido CartaoOnline salvo no localStorage (expira em 30min):', pedidoId);

            // ✅ CORREÇÃO CRÍTICA: Também atualizar state e ref para detecção imediata
            // Sem isso, o botão continua mostrando "Fazer Pedido" ao invés de "Finalizar Pagamento Cartão"
            existingCardPedidoRef.current = {
                _id: pedidoId,
                valor_total: valorTotal,
                createdAt
            };
            setHasExistingCardPedido(true);
            console.log('[FINALIZAR] ✅ State hasExistingCardPedido atualizado para TRUE - botão mudará para "Finalizar Pagamento Cartão"');
        } catch (error) {
            console.error('[FINALIZAR] Erro ao salvar pedido cartão no localStorage:', error);
        }
    }, [idEmpresa]);

    // ✅ Função para limpar pedido CARTÃO do localStorage (após pagamento confirmado/cancelado)
    const clearCardOrderFromStorage = useCallback(() => {
        try {
            if (!idEmpresa) return;

            const storageKey = `card_order_${idEmpresa}`;
            localStorage.removeItem(storageKey);
            console.log('[FINALIZAR] 🗑️ Pedido CartaoOnline removido do localStorage');

            existingCardPedidoRef.current = null;
            setHasExistingCardPedido(false);
        } catch (error) {
            console.error('[FINALIZAR] Erro ao limpar pedido cartão do localStorage:', error);
        }
    }, [idEmpresa]);

    // ✅ Função para abrir modal CARTÃO com pedido existente
    const handleOpenExistingCardPayment = useCallback(() => {
        if (existingCardPedidoRef.current) {
            console.log('[FINALIZAR] 💳 Abrindo modal CARTÃO para pedido existente:', existingCardPedidoRef.current._id);
            setPendingPedidoId(existingCardPedidoRef.current._id);
            setShowCardModal(true);
        }
    }, []);

    // ✅ Buscar configuração Tuna da empresa
    useEffect(() => {
        const fetchTunaConfig = async () => {
            try {
                if (!idEmpresa) return;

                const response = await getTunaConfigPublic(idEmpresa);
                if (response.success && response.enabled && response.config) {
                    setTunaEnabled(true);
                    setTunaConfig(response.config); // ✅ Extrair apenas config para acesso direto
                    console.log('[TUNA] Configuração carregada:', response.config);
                } else {
                    setTunaEnabled(false);
                    setTunaConfig(null);
                }
            } catch (error) {
                console.log('[TUNA] Pagamentos online não disponíveis:', error.message);
                setTunaEnabled(false);
                setTunaConfig(null);
            }
        };

        fetchTunaConfig();
    }, [idEmpresa]);

    // ✅ Verificar pedido PIX pendente quando selecionar PixOnline ou quando carrinho/entrega mudar
    // IMPORTANTE: Verifica se valor mudou para cancelar pedido antigo
    useEffect(() => {
        // Se usuário mudar de PixOnline para outra forma de pagamento
        if (paymentType !== "PixOnline" && hasExistingPixTransaction) {
            console.log('[FINALIZAR] 🔄 Forma de pagamento alterada, resetando transação PIX pendente');
            existingPixPedidoIdRef.current = null;
            existingPixValorRef.current = null;
            setHasExistingPixTransaction(false);
            return;
        }

        // ✅ Se está em PixOnline e tem transação pendente, verificar se valor mudou
        if (paymentType === "PixOnline" && hasExistingPixTransaction && existingPixPedidoIdRef.current && carrinho) {
            const calcularValorAtual = () => {
                if (!carrinho || carrinho.length === 0) return 0;
                let total = 0;
                carrinho.forEach(item => {
                    const itemTotal = typeof item.total === 'number' ? item.total : parseFloat(item.total) || 0;
                    total += itemTotal;
                });
                total += valorEntrega || 0;
                return total;
            };

            const valorAtual = calcularValorAtual();
            const pedidoId = existingPixPedidoIdRef.current;
            const isValid = checkExistingPixTransaction(pedidoId, valorAtual);

            if (!isValid) {
                console.log('[FINALIZAR] ⚠️ Transação PIX inválida (valor mudou ou expirou), resetando...');
                existingPixPedidoIdRef.current = null;
                existingPixValorRef.current = null;
                setHasExistingPixTransaction(false);
            }
        }
    }, [paymentType, hasExistingPixTransaction, carrinho, valorEntrega, checkExistingPixTransaction]);

    // ✅ Verificar pedido CARTÃO pendente quando selecionar CartaoOnline
    useEffect(() => {
        if (paymentType === "CartaoOnline" && idEmpresa && carrinho) {
            const calcularValorAtual = () => {
                if (!carrinho || carrinho.length === 0) return 0;
                let total = 0;
                carrinho.forEach(item => {
                    const itemTotal = typeof item.total === 'number' ? item.total : parseFloat(item.total) || 0;
                    total += itemTotal;
                });
                total += valorEntrega || 0;
                return total;
            };

            const valorAtual = calcularValorAtual();
            checkExistingCardOrder(valorAtual);
        } else if (paymentType !== "CartaoOnline" && hasExistingCardPedido) {
            console.log('[FINALIZAR] 🔄 Forma de pagamento alterada, resetando pedido cartão pendente');
            existingCardPedidoRef.current = null;
            setHasExistingCardPedido(false);
        }
    }, [paymentType, idEmpresa, carrinho, valorEntrega, checkExistingCardOrder, hasExistingCardPedido]);

    const [currentTime, setCurrentTime] = useState("");

    const [valueDescricao, setValueDescricao] = useState('');
    const descriptionRef = useRef();
    const handleMaxCharDescricao = (e) => {
        const newValue = e.target.value;
        if (newValue.length <= 200) {
            setValueDescricao(newValue);
        }
    };

    const calcularValorEntrega = useCallback(async (endereco) => {
        setCalculandoDistancia(true);
        if (regionType === "bairro") {
            // Pega o bairro do endereço
            const bairroSelecionado = endereco.bairro;

            // Busca flexível: case-insensitive, trim, e busca parcial (mesmo padrão do backend)
            const bairroNormalizado = (bairroSelecionado || '').toLowerCase().trim();
            const bairroEncontrado = bairros_entrega.find(bairro => {
                const bairroConfig = (bairro.bairro_entrega || '').toLowerCase().trim();
                return bairroConfig === bairroNormalizado ||
                       bairroConfig.includes(bairroNormalizado) ||
                       bairroNormalizado.includes(bairroConfig);
            });

            if (bairroEncontrado) {
                // Retorna o valor da entrega do bairro encontrado
                const valorEntrega = bairroEncontrado.valor_entrega;
                process.env.REACT_APP_ISDEVELOP === 'true' && console.log(`Valor da entrega para ${bairroSelecionado}: ${valorEntrega}`);
                setSelectedAddressToDelivery(endereco);
                setValorEntrega(valorEntrega);
                setCalculandoDistancia(false);
                return;
            } else {
                process.env.REACT_APP_ISDEVELOP === 'true' && console.log(`Bairro ${bairroSelecionado} não encontrado na lista de entrega`);
                setCalculandoDistancia(false);
                toast(t('checkout.deliveryUnavailable'), { autoClose: 5000, type: 'error' });
                return;
            }
        } else {
            try {
                // Coordenadas da empresa (ponto A)
                const coordenadasEmpresa = {
                    lat: empresa.latitude || empresa.lat,
                    lng: empresa.longitude || empresa.lng
                };

                // Coordenadas do cliente (ponto B)
                const coordenadasCliente = {
                    lat: endereco.latitude,
                    lng: endereco.longitude
                };

                // Validar se as coordenadas estão disponíveis
                if (!coordenadasEmpresa.lat || !coordenadasEmpresa.lng) {
                    process.env.REACT_APP_ISDEVELOP === 'true' && console.error("Coordenadas da empresa não disponíveis:", coordenadasEmpresa);
                    setCalculandoDistancia(false);
                    toast(t('checkout.coordsNotConfigured'), { autoClose: 5000, type: 'error' });
                    return;
                }

                if (!coordenadasCliente.lat || !coordenadasCliente.lng) {
                    process.env.REACT_APP_ISDEVELOP === 'true' && console.error("Coordenadas do endereço do cliente não disponíveis:", coordenadasCliente);
                    setCalculandoDistancia(false);
                    toast(t('checkout.addressCoordsNotFound'), { autoClose: 5000, type: 'error' });
                    return;
                }

                process.env.REACT_APP_ISDEVELOP === 'true' && console.log("Calculando distância entre:", coordenadasEmpresa, coordenadasCliente);

                // ✅ USAR VERSÃO SAFE QUE NUNCA REJEITA PROMISE
                const result = await calcularDistanciaSafe(coordenadasEmpresa, coordenadasCliente, idEmpresa);
                
                if (result.success && result.status === 200) {
                    // ✅ VERIFICAR FLAG delivery_available PARA SABER SE ESTÁ NO RAIO
                    if (result.data.delivery_available === false) {
                        // ❌ FORA DO RAIO - MAS SEM ERRO HTTP
                        process.env.REACT_APP_ISDEVELOP === 'true' && console.log("❌ ENTREGA NEGADA - Fora do raio:", result.data);
                        setCalculandoDistancia(false);
                        toast(`❌ ${result.data.message || t('deliveryNotAvailableRegion')}`, {
                            autoClose: 8000, 
                            type: 'error' 
                        });
                        // ✅ NÃO rejeitar promise - apenas retornar sem fazer nada
                        return;
                    } else {
                        // ✅ DENTRO DO RAIO - TUDO OK
                        process.env.REACT_APP_ISDEVELOP === 'true' && console.log("✅ ENTREGA APROVADA - Resposta:", result.data);
                        
                        const distancia = result.data.distance;
                        const valorEntrega = result.data.valor_entrega || 0;
                        
                        process.env.REACT_APP_ISDEVELOP === 'true' && console.log(`✅ ENTREGA APROVADA - Distância: ${distancia}km, Valor da entrega: ${formatPriceWithSymbol(valorEntrega)}`);
                        setSelectedAddressToDelivery(endereco);
                        setValorEntrega(valorEntrega);
                        setCalculandoDistancia(false);
                    }
                } else {
                    // ❌ ERRO REAL DE CONEXÃO/SERVIDOR
                    process.env.REACT_APP_ISDEVELOP === 'true' && console.log("❌ ERRO real ao calcular distância:", result);
                    setCalculandoDistancia(false);
                    toast(t('checkout.calcDistanceError'), { autoClose: 5000, type: 'error' });
                    // ✅ NÃO rejeitar promise - apenas retornar sem fazer nada
                    return;
                }
            } catch (error) {
                // ✅ FALLBACK: Caso ainda ocorra algum erro não esperado
                process.env.REACT_APP_ISDEVELOP === 'true' && console.error("⚠️ Erro não esperado em calcularValorEntrega:", error);
                setCalculandoDistancia(false);
                toast(t('checkout.unexpectedCalcError'), { autoClose: 5000, type: 'error' });
                // ✅ NÃO rejeitar promise - apenas retornar sem fazer nada
                return;
            }
        }
    }, [regionType, bairros_entrega, idEmpresa]);

    const [isSearchingClient, setIsSearchingClient] = useState(true);
    const [clientProcessed, setClientProcessed] = useState(false);
    
    useEffect(() => {
        const fetchClientData = async () => {
            if (carrinho.length === 0) {
            }
            // Usar dados locais do cliente - o registro no servidor ocorre junto com o pedido
            if (localPersonInfo && !clientProcessed) {
                try {
                    // Dados do cliente a partir do localStorage
                    const clienteData = {
                        nome: localPersonInfo.nome,
                        telefone: localPersonInfo.telefone,
                        endereco: localPersonInfo.endereco || []
                    };

                    // Buscar endereços do backend (registerClientePublic faz upsert e retorna endereco[])
                    try {
                        const idEmpresaFetch = idEmpresa || empresa?.id_empresa;
                        if (idEmpresaFetch && clienteData.telefone) {
                            const clienteResponse = await registerClientePublic(idEmpresaFetch, clienteData.nome, clienteData.telefone);
                            if (clienteResponse?.data?.cliente?.endereco) {
                                clienteData.endereco = clienteResponse.data.cliente.endereco;
                                process.env.REACT_APP_ISDEVELOP === 'true' && console.log('Endereços carregados do backend:', clienteData.endereco.length);
                            }
                        }
                    } catch (addrError) {
                        process.env.REACT_APP_ISDEVELOP === 'true' && console.log('Erro ao buscar endereços do backend, usando localStorage:', addrError.message);
                    }

                    process.env.REACT_APP_ISDEVELOP === 'true' && console.log('Cliente carregado:', clienteData);
                    setClientCompleteData(clienteData);
                    setIsSearchingClient(false);
                    setClientProcessed(true);

                    // 🔍 VALIDAÇÃO: Verificar se a opção salva ainda está disponível
                    const tipoSalvo = localPersonInfo.entrega.tipo_entrega;
                    const entregaIndisponivel = tipoSalvo === "Entrega" && empresa.entrega_disabled;
                    const retiradaIndisponivel = tipoSalvo === "Retirada" && empresa.retirada_disabled;
                    
                    if (entregaIndisponivel || retiradaIndisponivel) {
                        process.env.REACT_APP_ISDEVELOP === 'true' && console.log("🚨 Opção salva não está mais disponível durante carregamento!");
                        // Limpar dados de entrega
                        localPersonInfo.entrega = {};
                        localStorage.setItem('localPersonInfo', JSON.stringify(localPersonInfo));
                        // Não processar dados inválidos
                    } else {
                        // Opção ainda válida, processar normalmente
                        if (localPersonInfo.entrega.tipo_entrega === "Entrega") {
                            await calcularValorEntrega(localPersonInfo.entrega.endereco);
                            // ⚠️ NÃO restaurar tipo_pagamento - forçar cliente a escolher em cada pedido
                        } else if (localPersonInfo.entrega.tipo_entrega === "Retirada") {
                            setSelectedAddressToRetirada(enderecoEmpresa);
                            // ⚠️ NÃO restaurar tipo_pagamento - forçar cliente a escolher em cada pedido
                            setIsSearchingClient(false);
                            setClientProcessed(true);
                        }
                    }

                    // 🎯 SELEÇÃO AUTOMÁTICA: Verificar se há endereço para auto-seleção
                    if (personInfoObj && personInfoObj.autoSelectEnderecoId && clienteData.endereco) {
                        process.env.REACT_APP_ISDEVELOP === 'true' && console.log("🎯 Endereço para seleção automática detectado:", personInfoObj.autoSelectEnderecoId);

                        const enderecoParaSelecionar = clienteData.endereco.find(
                            endereco => endereco._id === personInfoObj.autoSelectEnderecoId
                        );
                        
                        if (enderecoParaSelecionar) {
                            process.env.REACT_APP_ISDEVELOP === 'true' && console.log("✅ Endereço encontrado para seleção automática:", enderecoParaSelecionar);
                            
                            // Aguardar um pouco para garantir que todos os states foram definidos
                            setTimeout(() => {
                                // ✅ PROMISE COM CATCH ROBUSTO - NÃO PERMITIR UNCAUGHT
                                calcularValorEntrega(enderecoParaSelecionar)
                                    .then(() => {
                                        // Auto-seleção silenciosa — toast já foi exibido no addEndereco.jsx
                                        process.env.REACT_APP_ISDEVELOP === 'true' && console.log("✅ Endereço recém-criado selecionado automaticamente");
                                    })
                                    .catch((error) => {
                                        // ❌ TRATAR TODOS OS ERROS SEM VAZAR PARA O RUNTIME
                                        process.env.REACT_APP_ISDEVELOP === 'true' && console.log("⚠️ Erro na seleção automática do endereço recém-criado:", error.message);
                                        // NÃO fazer throw aqui para evitar uncaught
                                    });
                            }, 500);
                            
                            // Limpar flag para evitar seleção em futuras navegações
                            delete personInfoObj.autoSelectEnderecoId;
                        } else {
                            process.env.REACT_APP_ISDEVELOP === 'true' && console.log("⚠️ Endereço para seleção não encontrado na lista");
                        }
                    }
                } catch (error) {
                    process.env.REACT_APP_ISDEVELOP === 'true' && console.log('Erro ao processar cliente:', error);
                    setIsSearchingClient(false);
                    setClientProcessed(true);
                }
            } else {
                setIsSearchingClient(false);
                setClientProcessed(true);
            }
        }
        fetchClientData();
    }, [carrinho.length, enderecoEmpresa, idEmpresa, localPersonInfo]);

    useEffect(() => {
        const fetchTime = async () => {
            try {
                if (empresa && currentTime === "" && isSearchingClient === false) {  // Only fetch if currentTime is not set or if data is not loading
                    const response = await axios.get('https://api.timezonedb.com/v2.1/get-time-zone', {
                        params: {
                            key: "7UIGZ1GOJE0U",
                            format: 'json',
                            by: 'zone',
                            zone: empresa.timezone
                        }
                    });
                    const newTime = response.data.formatted;
                    if (newTime !== currentTime) {  // Check if the new time is different
                        setCurrentTime(newTime);
                    }
                    process.env.REACT_APP_ISDEVELOP === 'true' && console.log("Timezone data fetched:", newTime);
                    //setLoadingData(false);  // Set loading to false after fetching the time
                }
            } catch (error) {
                process.env.REACT_APP_ISDEVELOP === 'true' && console.error('Erro ao obter o horário atual:', error);
                //setLoadingData(false);  // Also set loading to false on error
            }
        };
        fetchTime();
    }, [empresa, currentTime, isSearchingClient]);

    useEffect(() => {
        process.env.REACT_APP_ISDEVELOP === 'true' && console.log("🔄 Verificando itens no localStorage...");

        const itensCarrinhoTemp = localStorage.getItem('itensCarrinhoMobile')
            ? JSON.parse(localStorage.getItem('itensCarrinhoMobile'))
            : [];

        process.env.REACT_APP_ISDEVELOP === 'true' && console.log("🛒 Itens recuperados do localStorage:", itensCarrinhoTemp);

        if (itensCarrinhoTemp.length === 0) {
            process.env.REACT_APP_ISDEVELOP === 'true' && console.log("⚠️ Carrinho vazio. Redirecionando para a página do carrinho...");

            navigate(
                externalId
                    ? `${buildUrl('carrinho')}?external_id=${externalId}`
                    : buildUrl('carrinho')
            );
        }

        setCarrinho(itensCarrinhoTemp);
    }, [externalId, idEmpresa, navigate, nomeEmpresaForUrl, buildUrl]);

    // 🚨 VALIDAÇÃO DE CONFIGURAÇÕES DE ENTREGA/RETIRADA vs CACHE
    useEffect(() => {
        if (!empresa || Object.keys(empresa).length === 0) return;
        
        process.env.REACT_APP_ISDEVELOP === 'true' && console.log("🔍 Validando configurações de entrega/retirada...");
        process.env.REACT_APP_ISDEVELOP === 'true' && console.log("📋 Configurações da empresa:", {
            entrega_disabled: empresa.entrega_disabled,
            retirada_disabled: empresa.retirada_disabled
        });

        const localPersonInfo = JSON.parse(localStorage.getItem('localPersonInfo'));
        
        if (localPersonInfo && localPersonInfo.entrega && localPersonInfo.entrega.tipo_entrega) {
            const tipoSalvo = localPersonInfo.entrega.tipo_entrega;
            process.env.REACT_APP_ISDEVELOP === 'true' && console.log("💾 Tipo de entrega salvo no cache:", tipoSalvo);
            
            // Verificar se a opção salva ainda está disponível
            const entregaIndisponivel = tipoSalvo === "Entrega" && empresa.entrega_disabled;
            const retiradaIndisponivel = tipoSalvo === "Retirada" && empresa.retirada_disabled;
            
            if (entregaIndisponivel || retiradaIndisponivel) {
                process.env.REACT_APP_ISDEVELOP === 'true' && console.log("🚨 Opção salva não está mais disponível! Limpando cache...");
                
                // Limpar dados de entrega do cache
                localPersonInfo.entrega = {};
                localStorage.setItem('localPersonInfo', JSON.stringify(localPersonInfo));
                
                // Resetar estados
                setSelectedAddressToDelivery("");
                setSelectedAddressToRetirada("");
                setValorEntrega(0);
                
                // Mostrar toast informativo
                if (entregaIndisponivel && !empresa.retirada_disabled) {
                    toast.info(t('checkout.deliveryDisabled'), {
                        autoClose: 7000
                    });
                } else if (retiradaIndisponivel && !empresa.entrega_disabled) {
                    toast.info(t('checkout.pickupDisabled'), {
                        autoClose: 7000
                    });
                } else if (empresa.entrega_disabled && empresa.retirada_disabled) {
                    toast.error(t('checkout.bothDisabled'), {
                        autoClose: 7000
                    });
                }
            } else {
                // Opção salva ainda é válida, pode continuar usando
                process.env.REACT_APP_ISDEVELOP === 'true' && console.log("✅ Opção salva ainda está disponível:", tipoSalvo);
            }
        }
        
        // 🎯 AUTO-SELEÇÃO: Se apenas uma opção estiver disponível, selecionar automaticamente
        if (!localPersonInfo || !localPersonInfo.entrega || !localPersonInfo.entrega.tipo_entrega) {
            if (!empresa.entrega_disabled && empresa.retirada_disabled) {
                process.env.REACT_APP_ISDEVELOP === 'true' && console.log("🎯 Apenas entrega disponível - será selecionada quando usuário escolher endereço");
            } else if (empresa.entrega_disabled && !empresa.retirada_disabled) {
                process.env.REACT_APP_ISDEVELOP === 'true' && console.log("🎯 Apenas retirada disponível - selecionando automaticamente");
                setSelectedAddressToRetirada(enderecoEmpresa);
                
                // Salvar no localStorage também
                const updatedInfo = localPersonInfo || {};
                updatedInfo.entrega = {
                    tipo_entrega: "Retirada",
                    endereco: enderecoEmpresa,
                    valor: 0
                };
                localStorage.setItem('localPersonInfo', JSON.stringify(updatedInfo));
                
                toast.success(t('checkout.pickupAutoSelected'), {
                    autoClose: 3000
                });
            }
        }
    }, [empresa, enderecoEmpresa]);

    // 🎯 useEffect adicional para seleção automática quando clientCompleteData estiver disponível
    useEffect(() => {
        if (clientCompleteData && personInfoObj && personInfoObj.autoSelectEnderecoId && !selectedAddressToDelivery) {
            process.env.REACT_APP_ISDEVELOP === 'true' && console.log("🔄 Verificação adicional de seleção automática...");
            
            if (clientCompleteData.endereco && clientCompleteData.endereco.length > 0) {
                const enderecoParaSelecionar = clientCompleteData.endereco.find(
                    endereco => endereco._id === personInfoObj.autoSelectEnderecoId
                );
                
                if (enderecoParaSelecionar) {
                    process.env.REACT_APP_ISDEVELOP === 'true' && console.log("✅ Seleção automática (useEffect adicional):", enderecoParaSelecionar);
                    
                    setTimeout(() => {
                        // ✅ PROMISE COM CATCH ROBUSTO - NÃO PERMITIR UNCAUGHT
                        calcularValorEntrega(enderecoParaSelecionar)
                            .then(() => {
                                // Auto-seleção silenciosa — toast já foi exibido no addEndereco.jsx
                                process.env.REACT_APP_ISDEVELOP === 'true' && console.log("✅ Endereço selecionado automaticamente (useEffect adicional)");
                            })
                            .catch((error) => {
                                // ❌ TRATAR TODOS OS ERROS SEM VAZAR PARA O RUNTIME
                                process.env.REACT_APP_ISDEVELOP === 'true' && console.log("⚠️ Erro na seleção automática:", error.message);
                                // NÃO fazer throw aqui para evitar uncaught
                            });
                    }, 1000);
                    
                    // Limpar flag
                    delete personInfoObj.autoSelectEnderecoId;
                }
            }
        }
    }, [clientCompleteData, personInfoObj, selectedAddressToDelivery, calcularValorEntrega]);

    /*const handleDecrement = (id, index) => {
        setCarrinho(itens => {
            const itemToUpdate = itens[index];
            if (itemToUpdate.quantity === 1) {
                const filteredItems = itens.filter(item => item.id !== id);
                setItensCarrinho(filteredItems);
                localxStorage.setItem('itensCarrinho', JSON.stringify(filteredItems));
                return filteredItems;
            } else {
                itemToUpdate.quantity--;
                const updatedItems = [...itens.slice(0, index), itemToUpdate, ...itens.slice(index + 1)];
                setItensCarrinho(updatedItems);
                localxStorage.setItem('itensCarrinho', JSON.stringify(updatedItems));
                return updatedItems;
            }
        });
    }

    const handleIncrement = (id, index) => {
        setCarrinho(itens => {
            const itemToUpdate = itens[index];
            itemToUpdate.quantity++;
            const updatedItems = [...itens.slice(0, index), itemToUpdate, ...itens.slice(index + 1)];
            setItensCarrinho(updatedItems);
            localxStorage.setItem('itensCarrinho', JSON.stringify(updatedItems));
            return updatedItems;
        });
    }*/

    const handleChangeAddress = () => {
        const localPersonInfo = JSON.parse(localStorage.getItem('localPersonInfo'));
        if (localPersonInfo) {
            localPersonInfo.entrega = {};
            localStorage.setItem('localPersonInfo', JSON.stringify(localPersonInfo));
        }
        setSelectedAddressToDelivery("");
        setSelectedAddressToRetirada("");
        setValorEntrega(0);
        
        // 🎯 Verificar se apenas uma opção está disponível e selecionar automaticamente
        if (empresa.entrega_disabled && !empresa.retirada_disabled) {
            setTimeout(() => {
                setSelectedAddressToRetirada(enderecoEmpresa);
                toast.info(t('checkout.pickupAutoSelected'), {
                    autoClose: 3000
                });
            }, 500);
        }
    }

    function isStoreOpen(status_loja, schedule, currentTime) {
        if (!schedule && status_loja !== 'sempre') { return false; }
        if (status_loja === 'sempre') { return true; }
        if (!currentTime || currentTime === "") { return false; }
        // Extrai a data e a hora atual
        const now = new Date(currentTime);
        const currentDayOfWeek = now.getDay(); // Dias da semana como número (0=domingo, 1=segunda, etc.)
        const weekDays = ['domingo', 'segunda', 'terca', 'quarta', 'quinta', 'sexta', 'sabado'];
        const currentDayName = weekDays[currentDayOfWeek];

        // Checa se há um horário definido para o dia atual
        const periods = schedule[currentDayName];
        if (!periods) {
            return false; // Sem horários definidos para o dia
        }

        process.env.REACT_APP_ISDEVELOP === 'true' && console.log("schedule>", schedule)

        // Formata a hora e minuto atual para comparação
        const currentHour = now.getHours();
        const currentMinute = now.getMinutes();
        const currentTimeFormatted = currentHour * 100 + currentMinute; // HHMM como número

        // Verifica cada período de abertura

        for (const period of periods) {
            const startHourMinute = period.start.split(':').map(Number); // Converte "HH:MM" para [HH, MM]
            const endHourMinute = period.end.split(':').map(Number); // Converte "HH:MM" para [HH, MM]
            const startTime = startHourMinute[0] * 100 + startHourMinute[1]; // Converte para número HHMM
            const endTime = endHourMinute[0] * 100 + endHourMinute[1]; // Converte para número HHMM

            // Corrige o período que cruza a meia-noite
            if (endTime < startTime) {
                // Caso o tempo atual seja depois do início ou antes da "extensão" do período para o próximo dia
                if (currentTimeFormatted >= startTime || currentTimeFormatted < endTime) {
                    return true;
                }
            } else {
                // Caso o tempo atual esteja dentro do período normal
                if (currentTimeFormatted >= startTime && currentTimeFormatted < endTime) {
                    return true;
                }
            }
        }

        return false; // Nenhum período válido foi encontrado
    }

    /*const obtemValorItem = (valorItemEncrypted, quantidade) => {
        const decryptedPrice = CryptoJS.AES.decrypt(valorItemEncrypted, secretKey).toString(CryptoJS.enc.Utf8);
        const valorTotalItem = quantidade * parseFloat(decryptedPrice);
        let stringDescryptedPrice = valorTotalItem.toFixed(2).toString().replace('.',',');
        return stringDescryptedPrice;
    }    

    const calcularValorSubTotal = (itens) => {
        let total = 0;
        itens.forEach(item => {
            const valorItem = obtemValorItem(item.price, item.quantity);
            const valorItemFloat = parseFloat(valorItem.replace(',', '.'));
            total += valorItemFloat;
        });
        return total.toFixed(2).toString().replace('.', ',');
    }

    const calcularValorTotalPedido = (itens) => {
        let total = 0;
        itens.forEach(item => {
            const valorItem = obtemValorItem(item.price, item.quantity);
            const valorItemFloat = parseFloat(valorItem.replace(',', '.'));
            total += valorItemFloat;
        });
        total+=valorEntrega;
        return total.toFixed(2).toString().replace('.', ',');
    }*/



    const calcularValorSubTotal = (itens) => {
        let total = 0;
        itens.forEach(item => {
            const itemTotal = typeof item.total === 'number' ? item.total : parseFloat(item.total) || 0;
            total += itemTotal;
        });
        return total;
    };

    const calcularValorTotalPedido = (itens) => {
        let total = 0;
        itens.forEach(item => {
            const itemTotal = typeof item.total === 'number' ? item.total : parseFloat(item.total) || 0;
            total += itemTotal;
        });
        total += valorEntrega || 0;
        return total;
    };

    const handleAvancar = () => {
        if (whatsappData !== "" && namePersonData !== "") {
            setShowConfirmInfo(true)
            //setInfoPersonalData(true)
        }
        else
            toast(t('checkout.fillAllFields'), { autoClose: 3000, type: 'error' });
    }
    const valorTotalPedido = calcularValorTotalPedido(carrinho);
    const handlePaymentCash = () => {
        setShowModalPaymentCash(true);
        //process.env.REACT_APP_ISDEVELOP === 'true' && console.log(valorTroco);
        //setPaymentType(paymentType);
    }

    const handleCadastraEndereco = () => {
        personInfoObj = clientCompleteData;
        navigate(
            externalId
                ? `${buildUrl('cadastrar-endereco')}?external_id=${externalId}`
                : buildUrl('cadastrar-endereco'),
            { state: { personInfoObj } }
        );
    }

    const handleEdit = (id, e) => {
        e.stopPropagation();
        personInfoObj = clientCompleteData;
        const enderecoToEdit = personInfoObj.endereco.find(endereco => endereco._id === id);
        navigate(
            externalId
                ? `${buildUrl('cadastrar-endereco')}?external_id=${externalId}`
                : buildUrl('cadastrar-endereco'),
            { state: { personInfoObj, enderecoToEdit } }
        );
    }

    const handleDelete = (event, id) => {
        event.stopPropagation();
        deleteEnderecoClientePublic(idEmpresa, clientCompleteData.telefone, id).then(response => {
            if (response.status === 200) {
                //const personInfoObj = estava errado
                personInfoObj = response.data.response;
                setClientCompleteData(personInfoObj);
                toast(t('checkout.addressDeleted'), { autoClose: 3000, type: 'success' });
            }
            else {
                process.env.REACT_APP_ISDEVELOP === 'true' && console.log('Erro ao deletar endereço!');
            }
        });
    }

    /*useEffect(() => {
        process.env.REACT_APP_ISDEVELOP === 'true' && console.log("Entrou no useEffect")
        calcularValorEntrega();
    }, [selectedAddressToDelivery, selectedAddressToRetirada]);*/

    const handleClickRetirada = (endereco) => {
        setSelectedAddressToRetirada(endereco);
        setValorEntrega(0);
    }

    const handleFinalizarPedido = async () => {
        // 🛡️ PROTEÇÃO: Prevenir múltiplos cliques durante processamento
        if (isLoading) {
            console.log('⚠️ Pedido já está sendo processado, ignorando clique duplicado');
            return;
        }

        // 🔧 FIX: Buscar id_empresa dinamicamente do sessionStorage como fallback
        // Isso resolve o problema quando useMemo foi calculado antes do sessionStorage ser preenchido
        let idEmpresaFinal = idEmpresa;
        let empresaFinal = empresa;

        if (!idEmpresaFinal) {
            try {
                const sessionData = sessionStorage.getItem('sessionCompany');
                if (sessionData) {
                    const parsed = JSON.parse(sessionData);
                    idEmpresaFinal = parsed?.id_empresa;
                    empresaFinal = parsed;
                    console.log('🔄 [PEDIDO] id_empresa recuperado do sessionStorage:', idEmpresaFinal);
                }
            } catch (e) {
                console.error('❌ [PEDIDO] Erro ao ler sessionStorage:', e);
            }
        }

        // ✅ VALIDAÇÃO CRÍTICA: Garantir que temos id_empresa antes de prosseguir
        if (!idEmpresaFinal) {
            console.error('❌ [PEDIDO] id_empresa não disponível!', { idEmpresaParam, empresa, idEmpresa });
            toast.error(t('checkout.companyNotFound'));
            return;
        }

        // Usar empresaFinal para as verificações
        const empresaData = empresaFinal || empresa || {};

        // Verificar se ambos os serviços estão desabilitados
        if (empresaData.entrega_disabled && empresaData.retirada_disabled) {
            toast.error(t('checkout.noServicesAvailable'));
            return;
        }

        // Verificar se o tipo de entrega selecionado está disponível
        if (selectedAddressToDelivery !== "" && empresaData.entrega_disabled) {
            toast.error(t('checkout.deliveryTempUnavailable'));
            return;
        }

        if (selectedAddressToRetirada !== "" && empresaData.retirada_disabled) {
            toast.error(t('checkout.pickupTempUnavailable'));
            return;
        }

        //process.env.REACT_APP_ISDEVELOP === 'true' && console.log("empresa.status_loja>",empresa.status_loja)
        const statusLoja = isStoreOpen(empresaData.status_loja, empresaData.horario_funcionamento, currentTime);
        if (!statusLoja) {
            toast.error(<ToastWithLink
                empresa={empresaData}
                navigate={navigate} />, { toastId: 'store-closed-action' });
            return;
        }

        // ✅ Validar pedido mínimo (safety net - carrinho já bloqueia, mas valida novamente)
        const pedidoMinimoValor = empresaData?.pedido_minimo || 0;
        if (pedidoMinimoValor > 0) {
            const valorAtualPedido = calcularValorTotalPedido(carrinho) || 0;
            if (valorAtualPedido < pedidoMinimoValor) {
                toast.warning(t('checkout.minimumOrderNotReached', {
                    minimum: formatPriceWithSymbol(pedidoMinimoValor),
                    current: formatPriceWithSymbol(valorAtualPedido)
                }), { toastId: 'minimum-order-checkout' });
                return;
            }
        }

        const createdBy = "cardapio";
        const itens = carrinho.map(item => {
            const { _id, title, price, quantity, grupos_adicionais_selecionados, observacoes_item } = item;
            const valor = typeof price === 'number' ? price : parseFloat(price) || 0;
            return {
                objIdItem: _id,
                nomeItem: title,
                valor,
                quantidade: quantity,
                grupo_adicionais: grupos_adicionais_selecionados,
                obs_item: observacoes_item
            };
        });
        const celular_cliente = fromE164(clientCompleteData.telefone);
        const nome_cliente = clientCompleteData.nome;
        const tipo_pagamento = paymentType === 'Cartao' ? 'Cartão' : paymentType;
        const entrega = {
            tipo_entrega: selectedAddressToDelivery !== "" ? "Entrega" : "Retirada",
            endereco: selectedAddressToDelivery !== "" ? selectedAddressToDelivery : enderecoEmpresa,
            valor: valorEntrega
        }
        const desconto = 0;
        const cpf_cnpj = "";
        const valor_troco = valorTroco;
        const valor_total = calcularValorTotalPedido(carrinho);
        const descricao = valueDescricao;
        const external_id = externalId ? externalId : null;
        /*process.env.REACT_APP_ISDEVELOP === 'true' && console.log({
            createdBy,
            idEmpresa,
            itens,
            celular_cliente,
            nome_cliente,
            tipo_pagamento,
            entrega,          
            desconto,
            cpf_cnpj,
            valor_troco,
            valor_total,
            descricao,
            external_id
        })*/

        setIsLoading(true);
        setLoadingMessage(t('checkout.processingYourOrder'));

        try {
            // Verificar se já existe um token para reutilizar
            const existingToken = localStorage.getItem('session_token_pedeja');
            process.env.REACT_APP_ISDEVELOP === 'true' && console.log('🔐 Token existente encontrado:', existingToken);

            // ✅ GERAR CHAVE DE IDEMPOTÊNCIA: Evitar pedidos duplicados
            const idempotencyKey = `${idEmpresaFinal}_${celular_cliente}_${Date.now()}_${Math.random().toString(36).substring(2, 11)}`;
            process.env.REACT_APP_ISDEVELOP === 'true' && console.log('🔑 Idempotency Key gerada:', idempotencyKey);
            process.env.REACT_APP_ISDEVELOP === 'true' && console.log('🏢 id_empresa usado no pedido:', idEmpresaFinal);

            setLoadingMessage(t('checkout.sendingOrder'));

            const cast = await registerPedido(
                createdBy, idEmpresaFinal, itens, celular_cliente, nome_cliente, tipo_pagamento, entrega, desconto, cpf_cnpj, valor_troco, valor_total, descricao, external_id, existingToken, idempotencyKey
            );

            //process.env.REACT_APP_ISDEVELOP === 'true' && console.log("AQUI DEU BOM, CRIOU PEDIDO:::", cast);

            // ✅ ACEITAR TANTO 201 (novo) quanto 200 (duplicado detectado)
            if (cast.status === 201 || cast.status === 200) {
                if (cast.data.retry_payment) {
                    // ✅ RETRY DE PAGAMENTO: Pedido pendente encontrado para nova tentativa
                    console.log('🔄 Pedido pendente encontrado - tentando pagamento novamente');
                    setLoadingMessage(t('checkout.awaitingPayment'));
                } else if (cast.data.pedido_existente) {
                    console.log('⚠️ Requisição duplicada detectada pelo servidor');
                    setLoadingMessage(t('checkout.alreadyRegistered'));
                } else {
                    setLoadingMessage(t('checkout.orderSuccess'));
                }

                // ✅ SALVAR SESSION_TOKEN PARA TODOS OS TIPOS DE PAGAMENTO (incluindo online)
                console.log('[PEDIDO] Resposta do backend:', { session_token: cast.data.session_token, pedidoId: cast.data.pedidoId });
                if (cast.data.session_token) {
                    localStorage.setItem('session_token_pedeja', cast.data.session_token);
                    console.log('🔐 Session token salvo:', cast.data.session_token);

                    // 🚀 ATUALIZAÇÃO INSTANTÂNEA: Adicionar novo pedido ao cache
                    const cacheKey = `pedidos_cache_${cast.data.session_token}`;
                    const statusInicial = (paymentType === "PixOnline" || paymentType === "CartaoOnline") ? "0" : "1";

                    // Criar o novo pedido no cache
                    const novoPedido = {
                        _id: cast.data.pedido?._id || cast.data.pedidoId || `temp_${Date.now()}`,
                        id_pedido_counter: cast.data.id_pedido_counter,
                        status_pedido: statusInicial,
                        valor_total: valor_total,
                        tipo_pagamento: tipo_pagamento,
                        entrega: entrega,
                        createdAt: new Date().toISOString(),
                        payment_confirmed: false
                    };

                    try {
                        const existingCache = localStorage.getItem(cacheKey);
                        let pedidosData;

                        if (existingCache) {
                            pedidosData = JSON.parse(existingCache);
                            pedidosData.pedidos.unshift(novoPedido);
                        } else {
                            pedidosData = { pedidos: [novoPedido], timestamp: Date.now() };
                        }

                        pedidosData.timestamp = Date.now();
                        localStorage.setItem(cacheKey, JSON.stringify(pedidosData));
                        process.env.REACT_APP_ISDEVELOP === 'true' && console.log('⚡ Cache atualizado instantaneamente com novo pedido!', novoPedido);

                        // Disparar evento para atualizar contador na tela principal
                        window.dispatchEvent(new StorageEvent('storage', {
                            key: cacheKey,
                            newValue: JSON.stringify(pedidosData)
                        }));
                    } catch (error) {
                        console.error('Erro ao atualizar cache instantaneamente:', error);
                    }
                } else {
                    console.warn('⚠️ [PEDIDO] session_token NÃO retornado pelo backend!');
                }

                // ✅ PAGAMENTO PIX ONLINE - Abrir modal de pagamento
                if (paymentType === "PixOnline") {
                    const pedidoId = cast.data.pedido?._id || cast.data.pedidoId;
                    console.log('[TUNA] Abrindo modal PIX para pedido:', pedidoId);
                    setPendingPedidoId(pedidoId);
                    setShowPixModal(true);
                    setIsLoading(false);
                    return; // Não continuar com o fluxo normal
                }

                // ✅ PAGAMENTO CARTÃO ONLINE - Abrir modal de pagamento
                if (paymentType === "CartaoOnline") {
                    const pedidoId = cast.data.pedido?._id || cast.data.pedidoId;
                    console.log('[TUNA] Abrindo modal CARTÃO para pedido:', pedidoId);

                    // ✅ SALVAR NO LOCALSTORAGE: Para detectar pedido pendente se usuário fechar modal
                    saveCardOrderToStorage(pedidoId, valor_total);

                    setPendingPedidoId(pedidoId);
                    setShowCardModal(true);
                    setIsLoading(false);
                    return; // Não continuar com o fluxo normal
                }

                // ✅ Toast mais discreto - sem autoClose para não interferir na transição
                toast(cast.data.msg, { autoClose: 3000, type: "success" });

                // ✅ Armazenar session_token para rastreamento de pedidos (fluxo normal - já foi salvo acima)
                if (cast.data.session_token) {
                    localStorage.setItem('session_token_pedeja', cast.data.session_token);
                    process.env.REACT_APP_ISDEVELOP === 'true' && console.log('🔐 Session token salvo para rastreamento:', cast.data.session_token);
                    
                    // 🚀 ATUALIZAÇÃO INSTANTÂNEA: Incrementar contador de pedidos no cache
                    const cacheKey = `pedidos_cache_${cast.data.session_token}`;
                    const existingCache = localStorage.getItem(cacheKey);
                    
                    if (existingCache) {
                        try {
                            const pedidosData = JSON.parse(existingCache);
                            // Simular novo pedido com status "1" (análise)
                            const novoPedido = {
                                _id: `temp_${Date.now()}`,
                                status_pedido: "1",
                                createdAt: new Date().toISOString()
                            };
                            
                            // Adicionar ao cache existente
                            pedidosData.pedidos.unshift(novoPedido);
                            pedidosData.timestamp = Date.now();
                            
                            localStorage.setItem(cacheKey, JSON.stringify(pedidosData));
                            process.env.REACT_APP_ISDEVELOP === 'true' && console.log('⚡ Cache atualizado instantaneamente com novo pedido!');
                            
                            // Disparar evento para atualizar contador na tela principal
                            window.dispatchEvent(new StorageEvent('storage', {
                                key: cacheKey,
                                newValue: JSON.stringify(pedidosData)
                            }));
                            
                        } catch (error) {
                            process.env.REACT_APP_ISDEVELOP === 'true' && console.error('Erro ao atualizar cache instantaneamente:', error);
                        }
                    }
                }

                // Armazena as informações do cliente no localStorage
                // ⚠️ NÃO salvar tipo_pagamento - métodos online podem mudar entre pedidos
                localStorage.setItem('localPersonInfo', JSON.stringify({
                    nome: nome_cliente,
                    telefone: celular_cliente,
                    entrega: entrega
                    // tipo_pagamento removido - forçar cliente a escolher em cada pedido
                }));

                // Remove os itens do carrinho do localStorage
                localStorage.removeItem('itensCarrinhoMobile');

                // ✅ Finalizar carrinho no backend (tracking de abandono)
                try {
                    const pedidoId = cast.data.pedido?._id || cast.data.pedidoId;
                    if (pedidoId) {
                        await finalizarCarrinho(idEmpresaFinal, pedidoId);
                        process.env.REACT_APP_ISDEVELOP === 'true' && console.log("✅ Carrinho finalizado no backend");
                    }
                } catch (err) {
                    // Não bloquear fluxo se falhar
                    process.env.REACT_APP_ISDEVELOP === 'true' && console.log("⚠️ Erro ao finalizar carrinho no backend:", err);
                }

                // Limpa o estado do carrinho
                setCarrinho([]);
                // setItensCarrinho([]);  // Descomente se necessário

                process.env.REACT_APP_ISDEVELOP === 'true' && console.log("🛒 Carrinho limpo. Redirecionando para Meus Pedidos...");

                // 🚀 AGUARDAR UM POUCO PARA O USUÁRIO VER A MENSAGEM DE SUCESSO
                setTimeout(() => {
                    // 🎯 REDIRECIONAR DIRETO PARA MEUS PEDIDOS
                    const meusPedidosUrl = externalId
                        ? `${buildUrl('meus-pedidos')}?external_id=${externalId}`
                        : buildUrl('meus-pedidos');
                    
                    navigate(meusPedidosUrl);
                }, 1500); // 1.5 segundos para ver a mensagem de sucesso
            } else {
                setLoadingMessage(t('checkout.processingError'));
                toast(cast.data.msg, { autoClose: 5000, type: "error" });
            }
        } catch (err) {
            process.env.REACT_APP_ISDEVELOP === 'true' && console.log('Erro ao finalizar pedido:', err);
            setLoadingMessage(t('checkout.orderError'));
            
            const msg = err.response?.data?.msg || t('checkout.orderErrorRetry');
            toast(msg, { autoClose: 5000, type: "error" });
        } finally {
            // ✅ AGUARDAR UM POUCO ANTES DE REMOVER O LOADING (para o usuário ver a mensagem)
            setTimeout(() => {
                setIsLoading(false);
                setLoadingMessage(t('checkout.processingOrder'));
            }, 1000);
        }
    }

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: "instant" });
    }, []);

    return (
        <>
            {/* 🎨 OVERLAY DE LOADING ELEGANTE */}
            {isLoading && (
                <div style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: 'rgba(0, 0, 0, 0.7)',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    zIndex: 9999,
                    backdropFilter: 'blur(3px)'
                }}>
                    <div style={{
                        backgroundColor: 'white',
                        borderRadius: '16px',
                        padding: '30px',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        gap: '20px',
                        boxShadow: '0 20px 40px rgba(0,0,0,0.3)',
                        maxWidth: '300px',
                        textAlign: 'center',
                        margin: '20px'
                    }}>
                        <Loading 
                            type="spin" 
                            color="#4a90e2" 
                            height={40} 
                            width={40} 
                        />
                        <div>
                            <h3 style={{ 
                                margin: '0 0 8px 0', 
                                color: '#333',
                                fontSize: '18px',
                                fontWeight: '600'
                            }}>
                                {t('checkout.finishingOrder')}
                            </h3>
                            <p style={{ 
                                margin: 0, 
                                color: '#666',
                                fontSize: '14px'
                            }}>
                                {loadingMessage}
                            </p>
                        </div>
                    </div>
                </div>
            )}

            <div className="finalizar-page">
                <div className="finalizar-header">
                    <div className="finalizar-header-back" onClick={() => handleBack()}>
                        <svg xmlns="http://www.w3.org/2000/svg" width={22} height={22} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                            <polyline points="15 18 9 12 15 6" />
                        </svg>
                    </div>
                    <span className="finalizar-header-title">{t('checkout.finishingOrder')}</span>
                </div>

            <div className="finalizar-body">
                {isSearchingClient ? <Loading type={"spinningBubbles"} className="calculandoDistanciaLoading" />
                    :
                    <>
                        {calculandoDistancia && <Loading type={"spinningBubbles"} className="calculandoDistanciaLoading" />}
                        {clientCompleteData === "" ?
                            <div>
                                <form className="personal-data" style={{ padding: 10 }}>
                                    <div className="column items-start field-container mb-2">
                                        <label className="whatsappNumberFinalizarPedido">
                                            {t('checkout.whatsappWithDDD')}
                                        </label>
                                        <PhoneInput value={whatsappData} onChange={(val) => setWhatsappData(val || '')} className="field-input w-100 pa-3" />
                                    </div>
                                    <div className="column items-start field-container mb-2">
                                        <label className="whatsappNumberFinalizarPedido">
                                            {t('checkout.fullName')}
                                        </label>
                                        <input type="text" value={namePersonData} onChange={(e) => setNamePersonData(e.target.value)} className="field-input w-100 pa-3 whatsappNumberFinalizarPedidoInput" />
                                    </div>
                                    <div className="avancarFinalizarPedido">
                                        <button type="button" onClick={() => handleAvancar()}
                                            className={carrinho.length > 0 ? "btnAvancarFinalizarPedido" : "btnAvancarFinalizarPedido btnBlockNotEnabled"}
                                            disabled={carrinho.length > 0 ? false : true} readOnly={carrinho.length > 0 ? false : true} >
                                            <p style={{ marginBottom: "0px" }}>{t('product.advance')}</p>
                                        </button>
                                    </div>
                                    <p className="description-text font-1 mt-3" style={{ textAlign: "center" }}>
                                        {t('protectedEnvironment')}
                                    </p>
                                </form>
                            </div>
                            :
                            <>
                                <div className="checkout-form">
                                    <div className="delivery-info">
                                        <div>
                                            <p>{t('orderDeliveredTo')}</p>
                                            <h2>{clientCompleteData.nome}</h2>
                                            <p>{formatPhoneDisplay(clientCompleteData.telefone_completo || clientCompleteData.telefone)}</p>
                                        </div>
                                        <div>
                                            <button onClick={() => {
                                                setClientCompleteData("")
                                                setSelectedAddressToDelivery("")
                                                setSelectedAddressToRetirada("")
                                                setPaymentType("")
                                                localStorage.removeItem('localPersonInfo');
                                                
                                                // 🎯 Auto-seleção após limpar dados
                                                if (empresa.entrega_disabled && !empresa.retirada_disabled) {
                                                    setTimeout(() => {
                                                        setSelectedAddressToRetirada(enderecoEmpresa);
                                                        toast.info(t('checkout.pickupAutoSelected'), {
                                                            autoClose: 3000
                                                        });
                                                    }, 500);
                                                }
                                            }} className="btnChangeFimPedido">{t('checkout.change')}</button>
                                        </div>
                                    </div>

                                    <div className="delivery-method" style={{
                                        border: selectedAddressToDelivery !== "" ? '2px solid rgb(230,230,230)' : selectedAddressToRetirada !== "" && '2px solid rgb(230,230,230)'
                                    }}>

                                        {selectedAddressToDelivery !== "" || selectedAddressToRetirada !== "" ?
                                            <div className="withAddressSelected" style={{ fontSize: 20 }}>
                                                {selectedAddressToDelivery !== "" ? t('deliveryLabel') : t('pickupLabel')}
                                            </div>
                                            :
                                            <div className="withAddress" style={{ fontSize: clientCompleteData.endereco.length > 0 ? 16 : 22 }}>
                                                {empresa.entrega_disabled && empresa.retirada_disabled
                                                    ? t('checkout.servicesUnavailable')
                                                    : empresa.entrega_disabled
                                                        ? t('checkout.pickupAtStore')
                                                        : empresa.retirada_disabled
                                                            ? t('checkout.deliveryAvailable')
                                                            : t('checkout.selectDeliveryMethod')
                                                }
                                                {clientCompleteData.endereco.length > 0 && !empresa.entrega_disabled &&
                                                    <button className="buttonNewAddress" onClick={() => handleCadastraEndereco()}>
                                                        <span style={{ fontSize: 13, fontWeight: 700 }}>{t('newAddressBtn')}</span>
                                                    </button>
                                                }
                                            </div>
                                        }


                                        {selectedAddressToDelivery !== "" ?
                                            <>
                                                <div className="delivery-options" style={{ padding: '10px', display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }} onClick={() => setSelectedAddressToDelivery("")}>
                                                    <div className="endEntregaMap" style={{ display: 'flex', flexDirection: 'column', lineHeight: '1' }}>
                                                        <h6>{t('deliveryAddressLabel')}</h6>
                                                        <p style={{ fontSize: 13 }}>{selectedAddressToDelivery.rua}, {selectedAddressToDelivery.numero}</p>
                                                        <p style={{ fontSize: 13 }}>{selectedAddressToDelivery.bairro}, {selectedAddressToDelivery.cidade}</p>
                                                    </div>
                                                    <div>
                                                        <button onClick={(e) => {
                                                            e.stopPropagation();
                                                            personInfoObj = clientCompleteData;
                                                            const enderecoToEdit = selectedAddressToDelivery;
                                                            navigate(
                                                                externalId
                                                                    ? `${buildUrl('cadastrar-endereco')}?external_id=${externalId}`
                                                                    : buildUrl('cadastrar-endereco'),
                                                                { state: { personInfoObj, enderecoToEdit } }
                                                            );
                                                        }}
                                                            className="btnChangeFimPedido" style={{ maxWidth: '80px', fontSize: 12 }}>{t('checkout.change')}</button>
                                                    </div>
                                                </div>
                                                <div style={{ padding: 10, display: 'flex', gap: 5, alignItems: 'center' }}>
                                                    <FcClock />
                                                    <span style={{ fontSize: 14, color: "gray" }}>{t('estimatedDeliveryTime', { min: empresa.tempoEntregaMin, max: empresa.tempoEntregaMax })}</span>
                                                </div>
                                            </>
                                            :
                                            selectedAddressToRetirada !== "" ?
                                                <>
                                                    <div className="delivery-options" style={{ padding: '10px', display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }} onClick={() => setSelectedAddressToDelivery("")}>
                                                        <div className="endEntregaMap" style={{ display: 'flex', flexDirection: 'column', lineHeight: '1' }}>
                                                            <h6>{t('checkout.pickupAtStore')}</h6>
                                                            <p style={{ fontSize: 13 }}>{selectedAddressToRetirada.rua}, {selectedAddressToRetirada.numero}</p>
                                                            <p style={{ fontSize: 13 }}>{selectedAddressToRetirada.bairro}, {selectedAddressToRetirada.cidade}</p>
                                                        </div>
                                                        <div>
                                                            <button onClick={() => setSelectedAddressToRetirada("")}
                                                                className="btnChangeFimPedido" style={{ maxWidth: '80px', fontSize: 12 }}>{t('checkout.change')}</button>
                                                        </div>
                                                    </div>
                                                    <div style={{ padding: 10, display: 'flex', gap: 5, alignItems: 'center' }}>
                                                        <FcClock />
                                                        <span style={{ fontSize: 14, color: "gray" }}>{t('estimatedDeliveryTime', { min: empresa.tempoBalcaoMin, max: empresa.tempoBalcaoMax })}</span>
                                                    </div>
                                                </>
                                                :
                                                <>
                                                    {/* Verificar se ambos os serviços estão desabilitados */}
                                                    {process.env.REACT_APP_ISDEVELOP === 'true' && console.log("EMPRESA:::", empresa)}
                                                    {empresa.entrega_disabled && empresa.retirada_disabled ? (
                                                        <div style={{ 
                                                            padding: '20px', 
                                                            textAlign: 'center',
                                                            backgroundColor: '#fff3cd',
                                                            border: '1px solid #ffeaa7',
                                                            borderRadius: '8px',
                                                            margin: '10px'
                                                        }}>
                                                            <div style={{ fontSize: '24px', marginBottom: '10px' }}>⚠️</div>
                                                            <h4 style={{ color: '#856404', marginBottom: '8px' }}>{t('checkout.servicesUnavailable')}</h4>
                                                            <p style={{ color: '#856404', fontSize: '14px', margin: 0 }}>
                                                                {t('checkout.noServicesAvailable')}
                                                            </p>
                                                        </div>
                                                    ) : (
                                                        <>
                                                            {/* Opções de Entrega - só exibe se não estiver desabilitada */}
                                                            {!empresa.entrega_disabled && (
                                                                <>
                                                                    {clientCompleteData.endereco && clientCompleteData.endereco.length > 0 ?
                                                                        clientCompleteData.endereco.map((endereco, index) => {
                                                                            return (
                                                                                <div key={index} className="delivery-options" style={{ padding: '10px', display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }}
                                                                                    onClick={() => calcularValorEntrega(endereco)}>
                                                                                    <div className="endEntregaMap" style={{ display: 'flex', flexDirection: 'column', lineHeight: '1' }}>
                                                                                        <h6>{t('deliveryAddressLabel')}</h6>
                                                                                        <p style={{ fontSize: 13 }}>{endereco.rua}, {endereco.numero}</p>
                                                                                        <p style={{ fontSize: 13 }}>{endereco.bairro}, {endereco.cidade} - {endereco.estado}</p>
                                                                                        <div style={{ display: 'flex', gap: 20, paddingTop: 5 }}>
                                                                                            <span style={{ fontSize: 12, color: '#1095F3', fontWeight: 700, cursor: 'pointer' }}
                                                                                                onClick={(e) => handleEdit(endereco._id, e)}>{t('editBtn')}</span>
                                                                                            <span style={{ fontSize: 12, color: 'red', fontWeight: 700, cursor: 'pointer' }}
                                                                                                onClick={(event) => handleDelete(event, endereco._id)}>{t('deleteBtn')}</span>
                                                                                        </div>
                                                                                    </div>
                                                                                    <div>
                                                                                        <div style={{ cursor: 'pointer' }} className="checkRetirada" />
                                                                                    </div>
                                                                                </div>
                                                                            )
                                                                        })
                                                                        :
                                                                        <div className="delivery-options">
                                                                            <div className="address">
                                                                                <h4>{t('deliveryAddressLabel')}</h4>
                                                                                <button className="addAddressButton" onClick={() => handleCadastraEndereco()}
                                                                                    style={{
                                                                                        width: '100%',
                                                                                        border: 'none',
                                                                                        borderRadius: '4px',
                                                                                        background: '#1095F3',
                                                                                        color: 'white',
                                                                                        fontWeight: '600',
                                                                                        fontSize: '14px',
                                                                                        height: '35px',
                                                                                        marginTop: '10px',
                                                                                        marginBottom: '10px'
                                                                                    }}
                                                                                >
                                                                                    {t('checkout.registerAddress')}
                                                                                </button>
                                                                            </div>
                                                                        </div>
                                                                    }
                                                                </>
                                                            )}

                                                            {/* Feedback visual quando entrega está desabilitada */}
                                                            {empresa.entrega_disabled && !empresa.retirada_disabled && (
                                                                <div style={{ 
                                                                    padding: '15px', 
                                                                    backgroundColor: '#f8d7da',
                                                                    border: '1px solid #f5c6cb',
                                                                    borderRadius: '8px',
                                                                    margin: '10px 0'
                                                                }}>
                                                                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                                                        <span style={{ fontSize: '18px' }}>🚫</span>
                                                                        <div>
                                                                            <h6 style={{ color: '#721c24', margin: '0 0 4px 0', fontSize: '14px' }}>{t('checkout.deliveryTempUnavailable')}</h6>
                                                                            <p style={{ color: '#721c24', fontSize: '12px', margin: 0 }}>
                                                                                {t('checkout.selectPickup')}
                                                                            </p>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            )}

                                                            {/* Opção de Retirada - só exibe se não estiver desabilitada */}
                                                            {!empresa.retirada_disabled && (
                                                                <div style={{ 
                                                                    padding: '10px', 
                                                                    display: 'flex', 
                                                                    flexDirection: 'row', 
                                                                    justifyContent: 'space-between', 
                                                                    alignItems: 'center',
                                                                    border: empresa.entrega_disabled ? '2px solid #28a745' : 'none',
                                                                    borderRadius: empresa.entrega_disabled ? '8px' : '0',
                                                                    backgroundColor: empresa.entrega_disabled ? '#d4edda' : 'transparent'
                                                                }}
                                                                    onClick={() => handleClickRetirada(enderecoEmpresa)}>
                                                                    <div className="pickup">
                                                                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '4px' }}>
                                                                            <h6 style={{ margin: 0 }}>{t('checkout.pickupAtStore')}</h6>
                                                                            {empresa.entrega_disabled && (
                                                                                <span style={{ 
                                                                                    backgroundColor: '#28a745', 
                                                                                    color: 'white', 
                                                                                    fontSize: '10px', 
                                                                                    padding: '2px 6px', 
                                                                                    borderRadius: '12px',
                                                                                    fontWeight: 'bold'
                                                                                }}>
                                                                                    {t('checkout.availableBadge')}
                                                                                </span>
                                                                            )}
                                                                        </div>
                                                                        <p style={{ fontSize: 13 }}>{empresa?.logradouro}, {empresa?.address_number}</p>
                                                                        <p style={{ fontSize: 13 }}>{empresa?.bairro}, {empresa?.municipio} - {empresa?.estado}</p>
                                                                    </div>
                                                                    <div>
                                                                        <div style={{ cursor: 'pointer' }} className="checkRetirada" />
                                                                    </div>
                                                                </div>
                                                            )}

                                                            {/* Feedback visual quando retirada está desabilitada */}
                                                            {empresa.retirada_disabled && !empresa.entrega_disabled && (
                                                                <div style={{ 
                                                                    padding: '15px', 
                                                                    backgroundColor: '#f8d7da',
                                                                    border: '1px solid #f5c6cb',
                                                                    borderRadius: '8px',
                                                                    margin: '10px 0'
                                                                }}>
                                                                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                                                        <span style={{ fontSize: '18px' }}>🚫</span>
                                                                        <div>
                                                                            <h6 style={{ color: '#721c24', margin: '0 0 4px 0', fontSize: '14px' }}>{t('checkout.pickupTempUnavailable')}</h6>
                                                                            <p style={{ color: '#721c24', fontSize: '12px', margin: 0 }}>
                                                                                {t('checkout.selectDeliveryAddress')}
                                                                            </p>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            )}
                                                        </>
                                                    )}
                                                </>
                                        }
                                    </div>

                                    {selectedAddressToDelivery !== "" || selectedAddressToRetirada !== "" ?
                                        <div className={paymentType === "" ? "payment-method-selected" : "payment-method"}>
                                            <h3 style={{ padding: 10, fontSize: 20, fontWeight: '600' }}>
                                                {paymentType === "" ? t('checkout.selectPayment') : t('checkout.paymentMethod')}</h3>
                                            {paymentType !== "" ?
                                                <div style={{ background: 'white' }}>
                                                    <div style={{ padding: '10px 10px 0px 10px', display: 'flex', flexDirection: 'column' }}>
                                                        <span style={{ color: 'rgb(160,160,160)', fontSize: 13 }}>{t('chosenPaymentMethod')}</span>
                                                        <span style={{ color: 'rgb(160,160,160)', fontSize: 13 }}>
                                                            {paymentType === "PixOnline" || paymentType === "CartaoOnline" ? t('checkout.payOnline') : t('checkout.payOnDelivery')}
                                                        </span>
                                                    </div>
                                                    <div className="payment-option-selected">
                                                        {paymentType === "PixOnline" ?
                                                            <div style={{ display: 'flex', gap: 10, alignItems: 'center' }}>
                                                                <FaPix style={{ fontSize: 30, color: 'rgb(55,180,170)' }} />
                                                                <div style={{ display: 'flex', flexDirection: 'column' }}>
                                                                    <label style={{ fontWeight: '500' }}>{t('pixOnlineLabel')}</label>
                                                                    <span style={{ fontSize: 11, color: 'gray' }}>{t('payWithQrCode')}</span>
                                                                </div>
                                                            </div>
                                                            : paymentType === "CartaoOnline" ?
                                                                <div style={{ display: 'flex', gap: 10, alignItems: 'center' }}>
                                                                    <FaCreditCard style={{ fontSize: 28, color: '#1976d2' }} />
                                                                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                                                                        <label style={{ fontWeight: '500' }}>{t('creditCardLabel')}</label>
                                                                        <span style={{ fontSize: 11, color: 'gray' }}>{t('payOnlineLabel')}</span>
                                                                    </div>
                                                                </div>
                                                                : paymentType === "Pix" ?
                                                                    <div style={{ display: 'flex', gap: 10, alignItems: 'center' }}>
                                                                        <FaPix style={{ fontSize: 30, color: 'rgb(55,180,170)' }} />
                                                                        <label htmlFor="Pix">{t('pixLabel')}</label>
                                                                    </div>
                                                                    : paymentType === "Dinheiro" ?
                                                                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                                                            <div style={{ display: 'flex', gap: 10, alignItems: 'center' }}>
                                                                                {svgMoney()}
                                                                                <label htmlFor="Dinheiro">{t('checkout.cash')}</label>
                                                                            </div>
                                                                            {valorTroco > 0 &&
                                                                                <span style={{ fontSize: 13, fontWeight: 500 }}>{t('checkout.changeFor')} {formatPriceWithSymbol(valorTroco)}</span>
                                                                            }
                                                                        </div>
                                                                        : paymentType === "Cartão" ?
                                                                            <div style={{ display: 'flex', gap: 10, alignItems: 'center' }}>
                                                                                {svgCreditCard()}
                                                                                <label htmlFor="Cartão">{t('cardLabel')}</label>
                                                                            </div>
                                                                            : null
                                                        }
                                                        <div>
                                                            <button onClick={() => setPaymentType("")}
                                                                className="btnChangeFimPedido" style={{ maxWidth: '80px', fontSize: 12 }}>{t('checkout.change')}</button>
                                                        </div>
                                                    </div>
                                                </div>
                                                :
                                                <div className="payment-options">
                                                    {/* ✅ SEÇÃO: Pagar Online (Tuna) */}
                                                    {tunaEnabled && tunaConfig?.payment_methods_enabled && (
                                                        <>
                                                            <div style={{ background: 'linear-gradient(135deg, #00d4aa, #00a884)', display: 'flex', flexDirection: 'column', padding: 10 }}>
                                                                <span style={{ color: 'white', fontSize: 14, fontWeight: '500' }}>{t('checkout.payOnline')}</span>
                                                                <span style={{ color: 'rgba(255,255,255,0.9)', fontSize: 13 }}>{t('payNowAndFinish')}</span>
                                                            </div>

                                                            {/* PIX Online */}
                                                            {tunaConfig.payment_methods_enabled.pix && (
                                                                <div className="payment-option" onClick={() => setPaymentType("PixOnline")}>
                                                                    <div style={{ display: 'flex', gap: 10, alignItems: 'center' }}>
                                                                        <FaPix style={{ fontSize: 30, color: 'rgb(55,180,170)' }} />
                                                                        <div style={{ display: 'flex', flexDirection: 'column' }}>
                                                                            <label style={{ fontWeight: '500' }}>PIX</label>
                                                                            <span style={{ fontSize: 11, color: 'gray' }}>{t('payWithQrCodeNow')}</span>
                                                                        </div>
                                                                    </div>
                                                                    <div style={{ cursor: 'pointer' }} className="checkRetirada" />
                                                                </div>
                                                            )}

                                                            {/* Cartão de Crédito Online */}
                                                            {tunaConfig.payment_methods_enabled.credit_card && (
                                                                <div className="payment-option" onClick={() => setPaymentType("CartaoOnline")}>
                                                                    <div style={{ display: 'flex', gap: 10, alignItems: 'center' }}>
                                                                        <FaCreditCard style={{ fontSize: 28, color: '#1976d2' }} />
                                                                        <div style={{ display: 'flex', flexDirection: 'column' }}>
                                                                            <label style={{ fontWeight: '500' }}>{t('creditCardLabel')}</label>
                                                                            <span style={{ fontSize: 11, color: 'gray' }}>{t('payOnlineWithCard')}</span>
                                                                        </div>
                                                                    </div>
                                                                    <div style={{ cursor: 'pointer' }} className="checkRetirada" />
                                                                </div>
                                                            )}

                                                            <div style={{ borderTop: '2px dashed #e0e0e0', margin: '10px 0' }} />
                                                        </>
                                                    )}

                                                    {/* ✅ SEÇÃO: Pagar na Entrega */}
                                                    <div style={{ background: 'rgb(230,230,230)', display: 'flex', flexDirection: 'column', padding: 10 }}>
                                                        <span style={{ color: 'rgb(90,90,90)', fontSize: 14 }}>{t('checkout.payOnDelivery')}</span>
                                                        <span style={{ color: 'gray', fontSize: 13 }}>{t('payToDeliveryPerson')}</span>
                                                    </div>
                                                    {empresa.formas_pagamento.includes("Pix") && (
                                                        <div className="payment-option" onClick={() => setPaymentType("Pix")}>
                                                            <div style={{ display: 'flex', gap: 10, alignItems: 'center' }}>
                                                                <FaPix style={{ fontSize: 30, color: 'rgb(55,180,170)' }} />
                                                                <label htmlFor="Pix">{t('pixLabel')}</label>
                                                            </div>
                                                            <div style={{ cursor: 'pointer' }} className="checkRetirada" />
                                                        </div>
                                                    )}

                                                    {empresa.formas_pagamento.includes("Dinheiro") && (
                                                        <div className="payment-option" onClick={() => handlePaymentCash()}>
                                                            <div style={{ display: 'flex', gap: 10, alignItems: 'center' }}>
                                                                {svgMoney()}
                                                                <label htmlFor="Dinheiro">{t('checkout.cash')}</label>
                                                            </div>
                                                            <div style={{ cursor: 'pointer' }} className="checkRetirada" />
                                                        </div>
                                                    )}

                                                    {empresa.formas_pagamento.includes("Cartão") && (
                                                        <div className="payment-option" onClick={() => setPaymentType("Cartão")}>
                                                            <div style={{ display: 'flex', gap: 10, alignItems: 'center' }}>
                                                                {svgCreditCard()}
                                                                <label htmlFor="Cartão">{t('cardLabel')}</label>
                                                            </div>
                                                            <div style={{ cursor: 'pointer' }} className="checkRetirada" />
                                                        </div>
                                                    )}
                                                </div>
                                            }

                                        </div>
                                        :
                                        <div className="payment-method">
                                            <h3 style={{ padding: 10, fontSize: 16 }}>{t('checkout.selectPayment')}</h3>
                                            <div className="payment-options" style={{ height: 40, alignItems: 'center', display: 'flex', justifyContent: 'center' }}>
                                                <p style={{ fontSize: 13, textAlign: 'center', fontWeight: '400' }}>{t('selectDeliveryFirst')}</p>
                                            </div>
                                        </div>
                                    }

                                </div>

                                <div className="observacoesDetalhe">
                                    <div className="obsTextBox">
                                        <div className="obsText">
                                            <span>{t('checkout.observationsLabel')}</span>
                                        </div>
                                    </div>
                                </div>
                                <div className="obsTextBoxContainer obsContainerFinalizarPedido">
                                    <div className="obsTextBoxData">
                                        <textarea placeholder={t('checkout.observationsPlaceholder')}
                                            value={valueDescricao} onChange={handleMaxCharDescricao}
                                            maxLength="200" className="text-areaObs"
                                            ref={descriptionRef}
                                        />
                                        <div className="divCounterChar">{valueDescricao.length}/200</div>
                                    </div>
                                </div>
                                <div className="summary">
                                    <div className="subtotal">
                                        <span>{t('subtotalLabel')}</span>
                                        <Money value={calcularValorSubTotal(carrinho)} />
                                    </div>
                                    {selectedAddressToDelivery !== "" && selectedAddressToRetirada === "" ?
                                        <div className="taxa-entrega">
                                            <span>{t('deliveryFeeLabel')}</span>
                                            <Money value={valorEntrega || 0} />
                                        </div>
                                        : null
                                    }
                                    <div className="total">
                                        <span>{t('totalLabel')}</span>
                                        <Money value={calcularValorTotalPedido(carrinho)} />
                                    </div>
                                </div>
                                <div className="agreement">
                                    <label htmlFor="privacy-policy">
                                        {t('checkout.privacyPrefix', 'Concordei com a')}{' '}
                                        <a
                                            href={meuPdfPoliticaPrivacy}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            style={{ color: 'var(--color-primary, #1095F3)', fontWeight: 600, textDecoration: 'underline' }}
                                        >
                                            {t('checkout.privacyLink', 'Política de Privacidade')}
                                        </a>
                                        {' '}{t('checkout.privacySuffix', 'do Pede Já')}
                                    </label>
                                </div>
                                {empresa.entrega_disabled && empresa.retirada_disabled ?
                                    <div className="avancarDetalhe selectFinalizarPedidoDisabled" style={{ boxShadow: 'none' }}>
                                        <button type="button" className="btnAvancarDetalhe" style={{ backgroundColor: '#dc3545', opacity: 0.7 }}>
                                            <p style={{ marginBottom: "0px" }}>{t('checkout.servicesUnavailable')}</p>
                                        </button>
                                    </div>
                                    : selectedAddressToDelivery === "" && selectedAddressToRetirada === "" ?
                                        <div className="avancarDetalhe selectFinalizarPedidoDisabled" style={{ boxShadow: 'none' }}>
                                            <button type="button" className="btnAvancarDetalhe">
                                                <p style={{ marginBottom: "0px" }}>
                                                    {empresa.entrega_disabled
                                                        ? t('checkout.selectPickup')
                                                        : empresa.retirada_disabled
                                                            ? t('checkout.selectDeliveryAddress')
                                                            : t('checkout.selectDeliveryMethodMsg')
                                                    }
                                                </p>
                                            </button>
                                        </div>
                                        : paymentType === "" ?
                                            <div className="avancarDetalhe selectFinalizarPedidoDisabled" style={{ boxShadow: 'none' }}>
                                                <button type="button" className="btnAvancarDetalhe">
                                                    <p style={{ marginBottom: "0px" }}>{t('checkout.selectPayment')}</p>
                                                </button>
                                            </div>
                                            :
                                            <div className="avancarDetalhe selectFinalizarPedidoEnabled" style={{ boxShadow: 'none' }}>
                                                {
                                                    isLoading ?
                                                        <button type="button" disabled className="btnAvancarDetalhe" style={{ 
                                                            background: 'linear-gradient(135deg, #4a90e2, #357abd)',
                                                            position: 'relative',
                                                            overflow: 'hidden'
                                                        }}>
                                                            <div style={{ 
                                                                display: 'flex', 
                                                                alignItems: 'center', 
                                                                justifyContent: 'center',
                                                                gap: '10px'
                                                            }}>
                                                                <Loading 
                                                                    type="spin" 
                                                                    color="#ffffff" 
                                                                    height={20} 
                                                                    width={20} 
                                                                />
                                                                <p style={{ 
                                                                    marginBottom: "0px", 
                                                                    color: 'white',
                                                                    fontWeight: '500',
                                                                    fontSize: '14px'
                                                                }}>
                                                                    {loadingMessage}
                                                                </p>
                                                            </div>
                                                        </button>
                                                        :
                                                        <button
                                                            onClick={() => {
                                                                // ✅ Se existe transação PIX pendente, abrir modal diretamente
                                                                if (hasExistingPixTransaction && paymentType === "PixOnline" && existingPixPedidoIdRef.current) {
                                                                    handleOpenExistingPixPayment();
                                                                // ✅ Se existe pedido CARTÃO pendente, abrir modal diretamente
                                                                } else if (hasExistingCardPedido && paymentType === "CartaoOnline" && existingCardPedidoRef.current) {
                                                                    handleOpenExistingCardPayment();
                                                                } else {
                                                                    handleFinalizarPedido();
                                                                }
                                                            }}
                                                            disabled={isLoading}
                                                            className="btnAvancarDetalhe"
                                                            style={{
                                                                opacity: isLoading ? 0.6 : 1,
                                                                cursor: isLoading ? 'not-allowed' : 'pointer',
                                                                // ✅ Destaque visual quando é "Realizar Pagamento"
                                                                ...((hasExistingPixTransaction && paymentType === "PixOnline") ||
                                                                    (hasExistingCardPedido && paymentType === "CartaoOnline")) && {
                                                                    background: 'linear-gradient(135deg, #FF9800, #FFB74D)',
                                                                    animation: 'pulse 2s infinite'
                                                                }
                                                            }}
                                                        >
                                                            <p style={{ marginBottom: "0px" }}>
                                                                {hasExistingPixTransaction && paymentType === "PixOnline"
                                                                    ? t('checkout.finishPixPayment')
                                                                    : hasExistingCardPedido && paymentType === "CartaoOnline"
                                                                        ? t('checkout.finishCardPayment')
                                                                        : t('checkout.placeOrder')
                                                                }
                                                            </p>
                                                        </button>
                                                }
                                            </div>
                                }
                            </>
                        }

                        <ModalConfirmInfoCliente showConfirmInfo={showConfirmInfo}
                            setShowConfirmInfo={setShowConfirmInfo}
                            namePersonData={namePersonData}
                            whatsappData={whatsappData}
                            id_empresa={idEmpresa}
                            setClientCompleteData={setClientCompleteData}
                        />

                        <ModalPaymentCash
                            showModalPaymentCash={showModalPaymentCash}
                            setShowModalPaymentCash={setShowModalPaymentCash}
                            valorTroco={valorTroco}
                            setValorTroco={setValorTroco}
                            setPaymentType={setPaymentType}
                            valorTotalPedido={valorTotalPedido}
                        />



                        {/*<div className="btnAdicionarItens">
                    <button onClick={() => handleBack()}>
                        <span>Adicionar mais itens</span>
                    </button>
                </div>*/}
                    </>}
            </div>

        </div>

        {/* ✅ Modal PIX Online */}
        <ModalPaymentPix
            isOpen={showPixModal}
            onClose={() => {
                setShowPixModal(false);
                // ✅ Verificar se existe transação PIX pendente antes de fechar
                // NOTA: Não passamos valorAtual aqui pois o cliente ainda não alterou o carrinho
                // A verificação de valor é feita depois, quando carrinho/entrega mudar
                if (pendingPedidoId && checkExistingPixTransaction(pendingPedidoId)) {
                    console.log('[FINALIZAR] 💾 Transação PIX pendente detectada, mantendo referência:', pendingPedidoId);
                    existingPixPedidoIdRef.current = pendingPedidoId;
                    existingPixValorRef.current = valorTotalPedido; // ✅ Salvar valor para comparação
                    setHasExistingPixTransaction(true);
                } else {
                    existingPixPedidoIdRef.current = null;
                    existingPixValorRef.current = null;
                    setHasExistingPixTransaction(false);
                }
                setPendingPedidoId(null);
            }}
            amount={valorTotalPedido}
            pedidoId={pendingPedidoId}
            idEmpresa={idEmpresa}
            customer={{
                name: namePersonData,
                phone: whatsappData?.replace(/\D/g, ''),
                document: '' // CPF/CNPJ do titular é coletado separadamente no modal
            }}
            onPaymentSuccess={async (result) => {
                console.log('[TUNA] Pagamento PIX confirmado:', result);
                toast.success(t('paymentConfirmedPreparing'));

                // ✅ LIMPAR transação pendente após pagamento confirmado
                existingPixPedidoIdRef.current = null;
                existingPixValorRef.current = null;
                setHasExistingPixTransaction(false);

                // ✅ LIMPAR CARRINHO após pagamento confirmado
                localStorage.removeItem('itensCarrinhoMobile');
                setCarrinho([]);
                console.log('🛒 Carrinho limpo após pagamento PIX confirmado');

                // ✅ Finalizar carrinho no backend (tracking de abandono)
                try {
                    if (result?.pedido_id) {
                        await finalizarCarrinho(idEmpresa, result.pedido_id);
                        console.log('✅ Carrinho finalizado no backend após PIX');
                    }
                } catch (err) {
                    console.log('⚠️ Erro ao finalizar carrinho no backend:', err);
                }

                // ✅ Navegar para meus pedidos (igual aos outros tipos de pagamento)
                navigate(
                    externalId
                        ? `${buildUrl('meus-pedidos')}?external_id=${externalId}`
                        : buildUrl('meus-pedidos')
                );
            }}
            onPaymentFailed={(error) => {
                console.error('[TUNA] Pagamento falhou:', error);
                toast.error(t('paymentNotProcessed'));
                setShowPixModal(false);
            }}
        />

        {/* ✅ Modal Cartão Online */}
        <ModalPaymentCard
            isOpen={showCardModal}
            onClose={() => {
                setShowCardModal(false);
                setPendingPedidoId(null);
            }}
            amount={valorTotalPedido}
            pedidoId={pendingPedidoId}
            idEmpresa={idEmpresa}
            customer={{
                name: namePersonData,
                phone: whatsappData?.replace(/\D/g, ''),
                document: '' // CPF/CNPJ do titular é coletado separadamente no modal
            }}
            onPaymentSuccess={async (result) => {
                console.log('[TUNA] Pagamento CARTÃO confirmado:', result);
                toast.success(t('paymentApprovedPreparing'));

                // ✅ LIMPAR localStorage após pagamento confirmado
                clearCardOrderFromStorage();

                // ✅ LIMPAR CARRINHO após pagamento confirmado
                localStorage.removeItem('itensCarrinhoMobile');
                setCarrinho([]);
                console.log('🛒 Carrinho limpo após pagamento CARTÃO confirmado');

                // ✅ Finalizar carrinho no backend (tracking de abandono)
                try {
                    if (result?.pedido_id) {
                        await finalizarCarrinho(idEmpresa, result.pedido_id);
                        console.log('✅ Carrinho finalizado no backend após CARTÃO');
                    }
                } catch (err) {
                    console.log('⚠️ Erro ao finalizar carrinho no backend:', err);
                }

                // ✅ Navegar para meus pedidos (igual aos outros tipos de pagamento)
                navigate(
                    externalId
                        ? `${buildUrl('meus-pedidos')}?external_id=${externalId}`
                        : buildUrl('meus-pedidos')
                );
            }}
            onPaymentFailed={(error) => {
                console.error('[TUNA] Pagamento CARTÃO falhou:', error);
                toast.error(t('paymentNotApprovedCard'));
                // ✅ NÃO LIMPAR localStorage em caso de falha - permite retry
                setShowCardModal(false);
            }}
            maxInstallments={12}
        />
        </>
    );
}

export default FinalizarPedido;

const svgCreditCard = () => {
    return (
        <svg
            id="Layer_1"
            enableBackground="new 0 0 68 68"
            height={30}
            viewBox="0 0 68 68"
            width={30}
            xmlns="http://www.w3.org/2000/svg"
        >
            <g id="_x35_">
                <g>
                    <g>
                        <g>
                            <g>
                                <path
                                    d="m63.5814896 36.2649384-41.2045212 22.6769828c-2.2589283 1.243206-5.0979729.4197998-6.3411808-1.8391342l-12.5565136-22.8154182c-1.2432075-2.258934-.4198017-5.0979767 1.8391283-6.3411827l41.2045212-22.676981c2.2589302-1.243206 5.0979729-.4197984 6.3411789 1.8391328l12.5565147 22.8154221c1.2432089 2.2589297.4197989 5.0979723-1.8391275 6.3411784z"
                                    fill="#febc1f"
                                />
                            </g>
                        </g>
                        <g>
                            <g>
                                <path
                                    d="m62.6815987 34.6298218-41.2045212 22.676979c-2.2589283 1.243206-5.0979729.4197998-6.3411798-1.8391304l-12.5565146-22.815422c-1.2432075-2.2589302-.4198017-5.0979748 1.8391283-6.3411808l41.2045212-22.676981c2.2589302-1.2432063 5.0979729-.4197984 6.3411789 1.839133l12.5565176 22.8154214c1.2432022 2.2589302.4197998 5.0979748-1.8391304 6.3411808z"
                                    fill="#ffd475"
                                />
                            </g>
                        </g>
                        <g>
                            <g>
                                <g>
                                    <path
                                        d="m45.6230049 3.6340563-41.2044864 22.6770265c-2.2589364 1.2432098-3.0823236 4.0822697-1.839144 6.3411503l12.556531 22.8154602s-11.7001696-22.3759117 34.6528778-51.9958496c-1.2919114-.5804889-2.829345-.5732968-4.1657784.1622126z"
                                        fill="#febc1f"
                                    />
                                </g>
                            </g>
                        </g>
                        <g>
                            <g>
                                <path
                                    d="m6.2700973 35.4500999 1.5767589 2.8649979c.3974571.722187 1.3051071.9854317 2.0272923.5879745l43.4678116-23.9225845c.722187-.3974562.9854317-1.3051062.5879745-2.0272932l-1.5767593-2.8649998c-.3974563-.722187-1.3051063-.9854326-2.0272933-.5879764l-43.4678107 23.9225874c-.7221856.3974571-.9854307 1.3051071-.587974 2.0272941z"
                                    fill="#1d2943"
                                />
                            </g>
                        </g>
                        <g>
                            <g>
                                <path
                                    d="m5.8331218 34.656105 1.5767584 2.8650017c.3974571.7221832 1.3051066.9854317 2.0272927.5879745l43.4678116-23.9225883c.722187-.3974562.9854317-1.3051062.5879745-2.0272923l-1.5767593-2.8649998c-.3974571-.722187-1.3051071-.9854326-2.0272903-.5879765l-43.4678136 23.9225866c-.722186.3974571-.9854311 1.3051071-.587974 2.0272941z"
                                    fill="#4c5c75"
                                />
                            </g>
                        </g>
                    </g>
                    <g>
                        <g>
                            <path
                                d="m56.1312866 64.9452744-47.0325269.0000228c-2.5784349 0-4.6686702-2.0902367-4.6686711-4.6686707l-.0000087-26.0424384c-.000001-2.578434 2.0902333-4.6686687 4.6686683-4.6686687l47.0325279-.0000191c2.578434 0 4.6686707 2.0902328 4.6686707 4.6686687l.0000076 26.0424385c-.0000009 2.578434-2.0902338 4.6686669-4.6686678 4.6686669z"
                                fill="#5094ff"
                            />
                        </g>
                    </g>
                    <g>
                        <g>
                            <path
                                d="m9.0987463 63.0788879 47.0325241.0000191c2.5784378 0 4.6686707-2.0902367 4.6686745-4.6686707l.0000076-26.0424347c0-2.5784359-2.0902328-4.6686726-4.6686668-4.6686726l-47.032528-.000019c-2.5784345 0-4.6686697 2.0902328-4.6686707 4.6686687l-.0000085 26.0424386c-.0000009 2.578434 2.0902329 4.6686706 4.6686678 4.6686706z"
                                fill="#57b3fe"
                            />
                        </g>
                    </g>
                    <g>
                        <g>
                            <g>
                                <path
                                    d="m9.0987663 27.6990719 47.0325203.0000744c2.5784416 0 4.6686668 2.0902576 4.6686668 4.6686363l-.0000038 26.0424805s-.538311-25.2444992-55.4289742-28.8447552c.8519402-1.1314583 2.2023293-1.866436 3.7277909-1.866436z"
                                    fill="#5094ff"
                                />
                            </g>
                        </g>
                    </g>
                    <g>
                        <g>
                            <g>
                                <g>
                                    <path
                                        d="m57.1417618 54.6996574v.7245789h-.0096512c.0188637.9798889-.7984848 1.8029976-1.7838097 1.8029976l-4.7369461.0000038c-.9678459 0-1.8029671-.8079567-1.7838097-1.8029976h-.0096511v-.7245789h.1157036c.2796631-.7038727 1.0414467-1.1859894 1.8416023-1.1859894l4.4091377-.0000038c.8002701 0 1.5620537.4821167 1.8417206 1.1859894z"
                                        fill="#e3e7f0"
                                    />
                                </g>
                            </g>
                            <g>
                                <g>
                                    <path
                                        d="m55.3433418 56.50811-4.5790215.0000687c-.9225769.0000114-1.7944107-.6264191-1.9239235-1.5398598-.1577072-1.1123047.7025833-2.0666733 1.7845535-2.0666847l4.5610123-.0000687c.9783401-.0000153 1.889431.709938 1.9490089 1.6864586.0661317 1.0839882-.7909735 1.9200745-1.7916297 1.9200859z"
                                        fill="#fff"
                                    />
                                </g>
                            </g>
                        </g>
                        <g>
                            <g>
                                <g>
                                    <path
                                        d="m43.5652237 54.6996613v.7245827h-.0096512c.0188637.9798851-.7984848 1.8029938-1.7838097 1.8029938l-4.7369461.0000038c-.9678459 0-1.8029671-.8079567-1.7838097-1.8029938h-.0096512v-.7245827h.1157036c.2796631-.7038727 1.0414467-1.1859894 1.8416023-1.1859894l4.4091377-.0000038c.8002701 0 1.5620537.4821167 1.8417206 1.1859894z"
                                        fill="#e3e7f0"
                                    />
                                </g>
                            </g>
                            <g>
                                <g>
                                    <path
                                        d="m41.7668037 56.5081139-4.5790253.0000687c-.9225769.0000153-1.7944069-.6264191-1.9239197-1.5398598-.1577072-1.1123009.7025833-2.0666695 1.7845535-2.0666809l4.5610123-.0000725c.9783363-.0000114 1.889431.7099419 1.9490089 1.6864624.0661317 1.0839843-.7909735 1.9200706-1.7916297 1.9200821z"
                                        fill="#fff"
                                    />
                                </g>
                            </g>
                        </g>
                        <g>
                            <g>
                                <g>
                                    <path
                                        d="m29.9886837 54.6996689v.7245789h-.0096512c.0188656.9798851-.7984829 1.8029976-1.7838097 1.8029976h-4.7369442c-.9678478 0-1.8029671-.8079529-1.7838097-1.8029938h-.0096531v-.7245827h.1157036c.279665-.7038689 1.0414486-1.1859894 1.8416023-1.1859894h4.4091377c.800272 0 1.5620556.4821167 1.8417206 1.1859894z"
                                        fill="#e3e7f0"
                                    />
                                </g>
                            </g>
                            <g>
                                <g>
                                    <path
                                        d="m28.1902657 56.5081177-4.5790234.0000725c-.9225769.0000114-1.7944088-.6264191-1.9239197-1.5398598-.1577091-1.1123047.7025814-2.0666733 1.7845497-2.0666847l4.5610161-.0000687c.9783363-.0000153 1.8894291.709938 1.9490051 1.6864586.0661316 1.0839844-.7909717 1.9200744-1.7916278 1.9200821z"
                                        fill="#fff"
                                    />
                                </g>
                            </g>
                        </g>
                        <g>
                            <g>
                                <g>
                                    <path
                                        d="m16.4121456 54.6996727v.7245827h-.0096512c.0188656.9798851-.7984838 1.8029938-1.7838097 1.8029938l-4.7369441.0000038c-.9678478 0-1.802968-.8079567-1.7838106-1.8029976h-.0096522v-.7245789h.1157036c.279665-.7038727 1.0414476-1.1859894 1.8416023-1.1859894l4.4091377-.0000038c.800272 0 1.5620556.4821167 1.8417206 1.1859894z"
                                        fill="#e3e7f0"
                                    />
                                </g>
                            </g>
                            <g>
                                <g>
                                    <path
                                        d="m14.6137276 56.5081253-4.5790243.0000687c-.9225769.0000114-1.7944078-.6264191-1.9239197-1.5398598-.1577077-1.1123009.7025814-2.0666733 1.7845497-2.0666847l4.5610161-.0000687c.9783363-.0000153 1.88943.709938 1.9490061 1.6864586.0661315 1.0839882-.7909708 1.9200745-1.7916279 1.9200859z"
                                        fill="#fff"
                                    />
                                </g>
                            </g>
                        </g>
                    </g>
                    <g>
                        <g>
                            <g>
                                <path
                                    d="m8.0920725 35.925663.0000019 4.3564262c0 1.0981369.890214 1.9883499 1.988348 1.9883461l8.1573095-.0000229c1.098135 0 1.988348-.890213 1.988348-1.9883461l-.0000019-4.3564301c0-1.0981331-.8902149-1.9883461-1.988348-1.9883461l-8.1573105.0000229c-1.098134.0000039-1.988347.8902169-1.988347 1.98835z"
                                    fill="#febc1f"
                                />
                            </g>
                        </g>
                        <g>
                            <g>
                                <path
                                    d="m8.0920725 35.2468109.000001 4.3564262c.000001 1.0981331.890214 1.9883461 1.988348 1.9883461l8.1573105-.0000229c1.0981331 0 1.988348-.8902168 1.9883461-1.9883499v-4.3564262c-.0000019-1.0981331-.8902149-1.9883461-1.988348-1.9883461l-8.1573114.0000229c-1.0981342 0-1.9883472.890213-1.9883462 1.9883499z"
                                    fill="#ffd475"
                                />
                            </g>
                        </g>
                    </g>
                    <g>
                        <g>
                            <g>
                                <path
                                    d="m13.9477558 36.954998v-3.6965523h-.9444408v3.6965523h-4.9112435v.9444428h2.6869421v3.6921043h.9444418v-3.6921043h4.2524815v3.6921043h.9444065v-3.6921043h3.305748v-.9444428z"
                                    fill="#febc1f"
                                />
                            </g>
                        </g>
                    </g>
                    <g>
                        <g>
                            <g>
                                <g>
                                    <path
                                        d="m56.2796402 40.2164574-5.3172913.0000305c-.443058.0000076-.8617401-.300827-.9239388-.7394943-.075737-.5341682.3374062-.9924927.8570061-.9924965l5.3086472-.0000343c.4698334-.0000076.9073715.3409386.9359818.8098984.0317611.5205688-.3798523.9220885-.860405.9220962z"
                                        fill="#fff"
                                    />
                                </g>
                            </g>
                        </g>
                        <g>
                            <g>
                                <g>
                                    <path
                                        d="m56.2796402 36.5089836-9.3353691.0000343c-.4430542.0000038-.8617401-.3008308-.9239349-.7394981-.075737-.5341682.3374023-.9924927.8570061-.9924965l9.3267212-.0000343c.4698334-.0000076.9073715.3409386.9359818.8099022.031761.5205688-.3798524.9220886-.8604051.9220924z"
                                        fill="#fff"
                                    />
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
                <g>
                    <g>
                        <path
                            d="m54.8607178 16.3203678c2.2225723 2.8520584 4.0391045 5.9515629 5.4309731 9.2891464-2.225937-2.8498039-4.0357934-5.9533443-5.4309731-9.2891464z"
                            fill="#fff"
                        />
                    </g>
                </g>
                <g>
                    <g>
                        <path
                            d="m13.4443359 25.6074772c3.2388935-2.4783745 6.7269783-4.5519123 10.456749-6.2024593-3.2368565 2.4816837-6.7289753 4.5484409-10.456749 6.2024593z"
                            fill="#fff"
                        />
                    </g>
                </g>
                <g>
                    <g>
                        <path
                            d="m40.1918945 60.7349167c4.0498962-.4790192 8.107563-.4831581 12.1573486.0000458-4.0497855.4831161-8.1074485.4792175-12.1573486-.0000458z"
                            fill="#fff"
                        />
                    </g>
                </g>
            </g>
        </svg>
    )
}

const svgMoney = () => {
    return (
        <svg
            id="Layer_1"
            enableBackground="new 0 0 50 50"
            height={30}
            viewBox="0 0 50 50"
            width={30}
            xmlns="http://www.w3.org/2000/svg"
        >
            <g>
                <g>
                    <g>
                        <g>
                            <g enableBackground="new">
                                <g>
                                    <path
                                        d="m49 32.34555-.0152 4.5598-14.2916 8.3053.0152-4.5597z"
                                        fill="#5eaf5f"
                                    />
                                </g>
                                <g>
                                    <path
                                        d="m34.7084 40.65095-.0152 4.5597-33.6932-19.4527.0153-4.5597z"
                                        fill="#7bc578"
                                    />
                                </g>
                                <g>
                                    <path
                                        d="m49 32.34555-14.2916 8.3054-33.6931-19.4527 14.2916-8.3054z"
                                        fill="#98d095"
                                    />
                                </g>
                            </g>
                        </g>
                        <g>
                            <path
                                d="m36.7837 31.52105-.3891.2261c.3441.3097.3463.6854-.037.9082l-.5002-.2888c.1738-.101.0883-.3306-.1829-.4872-.2772-.16-.6738-.2088-.8476-.1078-.1735.1008-.0883.3306.1889.4907.5604.3235.6415.8.1864 1.0645-.3833.2228-1.0319.2227-1.5618.021l-.3892.2261-.5001-.2887.3891-.2262c-.3499-.3063-.3522-.682.0311-.9047l.5002.2888c-.1738.101-.0825.3271.1947.4872.2712.1566.662.2087.8358.1077.1796-.1044.088-.3304-.1832-.4869-.5604-.3236-.6472-.8038-.1921-1.0683.3833-.2227 1.0319-.2226 1.5677-.0243l.3891-.2262z"
                                fill="#46a046"
                            />
                        </g>
                        <g>
                            <path
                                d="m17.2645 20.25165-.3892.2261c.3441.3097.3524.6889-.0309.9116l-.5062-.2923c.1737-.1009.0943-.3271-.1829-.4871-.2772-.1601-.6739-.2088-.8476-.1078-.1735.1008-.0884.3306.1889.4906.5604.3236.6475.8036.1924 1.068-.3833.2228-1.038.2193-1.5679.0176l-.3891.2261-.5002-.2888.3892-.2261c-.35-.3063-.3522-.682.0311-.9048l.5002.2888c-.1738.101-.0825.3272.1947.4873.2772.16.662.2087.8358.1077.1796-.1044.094-.3269-.1832-.487-.5605-.3236-.6472-.8037-.1921-1.0682.3833-.2227 1.0319-.2227 1.5676-.0244l.3892-.2261z"
                                fill="#46a046"
                            />
                        </g>
                        <g>
                            <path
                                d="m16.6976 15.60325c.7654.4419.7694 1.1516.009 1.5936-.7542.4383-1.9858.4418-2.7511 0-.7593-.4384-.7632-1.1552-.009-1.5936.7604-.4419 1.9918-.4384 2.7511 0z"
                                fill="#46a046"
                            />
                        </g>
                        <g>
                            <path
                                d="m29.9871 24.59375-.9637.5601c.857.7586.8624 1.684-.0897 2.2373l-1.2354-.7133c.431-.2505.2176-.8106-.4634-1.2038-.6749-.3897-1.6487-.5149-2.0797-.2645-.431.2505-.2116.8141.4634 1.2038 1.386.8003 1.5968 1.9763.4713 2.6304-.9459.5497-2.5497.5532-3.856.0557l-.9699.5636-1.2354-.7132.9699-.5637c-.8632-.755-.8684-1.6875.0775-2.2372l1.2354.7133c-.4311.2505-.2116.8141.4634 1.2038.6809.3931 1.6486.515 2.0797.2645.431-.2505.2176-.8107-.4634-1.2038-1.38-.7968-1.591-1.9797-.4713-2.6304.9521-.5533 2.5557-.5497 3.8682-.0558l.9637-.5601z"
                                fill="#46a046"
                            />
                        </g>
                        <g>
                            <path
                                d="m8.4413 20.40135c.7653.4419.7693 1.1516.0092 1.5933-.7545.4385-1.9799.4385-2.7452-.0033-.7593-.4384-.7694-1.1517-.0148-1.5902.7601-.4417 1.9915-.4382 2.7508.0002z"
                                fill="#46a046"
                            />
                        </g>
                        <g>
                            <path
                                d="m44.3102 31.54535c.7654.4419.7694 1.1517.009 1.5936-.7543.4383-1.9858.4419-2.7511 0-.7593-.4384-.7572-1.1517-.003-1.5901.7605-.4419 1.9858-.4419 2.7451-.0035z"
                                fill="#46a046"
                            />
                        </g>
                        <g>
                            <path
                                d="m36.0539 36.34345c.7653.4419.7693 1.1517.0092 1.5934-.7545.4385-1.9799.4385-2.7452-.0034-.7593-.4384-.7634-1.1482-.0088-1.5867.7601-.4417 1.9854-.4417 2.7448-.0033z"
                                fill="#46a046"
                            />
                        </g>
                        <g>
                            <path
                                d="m15.3202 14.19765 31.4272 18.1445-12.0461 7.0004-12.9445-7.4735-18.4827-10.671zm3.7006 16.05c3.3265 1.9205 8.7145 1.917 12.0134-.0001s3.2874-5.0381-.0391-6.9586c-3.3206-1.9171-8.7146-1.9171-12.0135 0s-3.2814 5.0416.0392 6.9587m-10.1546-8.0198 6.8157 3.9072c.2215-1.1759 1.1042-2.3172 2.6549-3.2184s3.5119-1.4125 5.5475-1.5483l-6.7916-3.9212c1.0056-.5844 1.0006-1.51.0123-2.0806-.9823-.5671-2.5863-.5705-3.5683.0001-.9819.5707-.9647 1.4962.0176 2.0633l-4.6756 2.7521c-1.0124-.5846-2.6164-.5879-3.5922-.0209-.9877.5741-.9705 1.4996.0118 2.0667.9883.5706 2.5801.5741 3.5679 0m27.595 13.8789 4.6816-2.7486c1.0124.5845 2.6042.588 3.5861.0174.982-.5707.977-1.4963-.0114-2.0669-.9822-.5671-2.5802-.567-3.5622.0037l-6.8153-3.9074c-.2338 1.1761-1.1103 2.3137-2.661 3.2149s-3.518 1.4161-5.5415 1.5518l6.7917 3.9212c-1.0118.588-1.0006 1.51-.0183 2.0771.9883.5706 2.5801.5741 3.5679.0001.9757-.5671.9707-1.4927-.0176-2.0633m-16.7862-18.7221-.892.5184 3.6399 2.1015.8919-.5184zm17.9162 10.344-.892.5183 3.6339 2.098.892-.5183zm-25.1609-1.9171.8861-.515-3.6398-2.1014-.8862.5149zm17.9102 10.3405.8862-.515-3.6339-2.098-.8861.515z"
                                fill="#46a046"
                            />
                        </g>
                    </g>
                    <g>
                        <g enableBackground="new">
                            <g>
                                <path
                                    d="m35.7416 24.69085-14.2916 8.3053-.658-.3799 14.2916-8.3054z"
                                    fill="#86aedc"
                                />
                            </g>
                            <g>
                                <path
                                    d="m39.5801 26.90695-14.2916 8.3054-3.8385-2.2162 14.2916-8.3053z"
                                    fill="#e3e6f0"
                                />
                            </g>
                            <g>
                                <path
                                    d="m40.2342 27.28455-14.2916 8.3054-.6541-.3776 14.2916-8.3054z"
                                    fill="#86aedc"
                                />
                            </g>
                        </g>
                    </g>
                    <g>
                        <g enableBackground="new">
                            <g>
                                <path
                                    d="m21.4496 32.99595-.0299 4.5611-.6577-.3797.03-4.5611z"
                                    fill="#678cc8"
                                />
                            </g>
                            <g>
                                <path
                                    d="m25.285 35.21035-.03 4.561-3.8353-2.2143.0299-4.5611z"
                                    fill="#d4dbe9"
                                />
                            </g>
                            <g>
                                <path
                                    d="m25.9426 35.58995-.0299 4.5611-.6577-.3797.03-4.561z"
                                    fill="#678cc8"
                                />
                            </g>
                        </g>
                    </g>
                </g>
                <g>
                    <g>
                        <g>
                            <g enableBackground="new">
                                <g>
                                    <path
                                        d="m49 24.24205-.0152 4.5597-14.2916 8.3054.0152-4.5597z"
                                        fill="#5eaf5f"
                                    />
                                </g>
                                <g>
                                    <path
                                        d="m34.7084 32.54745-.0152 4.5597-33.6932-19.4527.0153-4.5598z"
                                        fill="#7bc578"
                                    />
                                </g>
                                <g>
                                    <path
                                        d="m49 24.24205-14.2916 8.3054-33.6931-19.4528 14.2916-8.3053z"
                                        fill="#98d095"
                                    />
                                </g>
                            </g>
                        </g>
                        <g>
                            <path
                                d="m36.7837 23.41755-.3891.2261c.3441.3097.3463.6854-.037.9081l-.5002-.2887c.1738-.101.0883-.3306-.1829-.4872-.2772-.16-.6738-.2088-.8476-.1078-.1735.1008-.0883.3306.1889.4906.5604.3236.6415.8001.1864 1.0646-.3833.2227-1.0319.2227-1.5618.021l-.3892.2261-.5001-.2888.3891-.2261c-.3499-.3063-.3522-.682.0311-.9047l.5002.2887c-.1738.101-.0825.3272.1947.4873.2712.1565.662.2087.8358.1077.1796-.1044.088-.3304-.1832-.487-.5604-.3235-.6472-.8037-.1921-1.0682.3833-.2227 1.0319-.2227 1.5677-.0244l.3891-.2261z"
                                fill="#46a046"
                            />
                        </g>
                        <g>
                            <path
                                d="m17.2645 12.14805-.3892.2262c.3441.3096.3524.6888-.0309.9116l-.5062-.2923c.1737-.101.0943-.3271-.1829-.4871-.2772-.1601-.6739-.2088-.8476-.1078-.1735.1008-.0884.3305.1889.4906.5604.3236.6475.8036.1924 1.068-.3833.2228-1.038.2192-1.5679.0175l-.3891.2262-.5002-.2888.3892-.2262c-.35-.3062-.3522-.6819.0311-.9047l.5002.2888c-.1738.101-.0825.3272.1947.4872.2772.1601.662.2088.8358.1078.1796-.1044.094-.327-.1832-.487-.5605-.3236-.6472-.8038-.1921-1.0682.3833-.2228 1.0319-.2227 1.5676-.0244l.3892-.2261z"
                                fill="#46a046"
                            />
                        </g>
                        <g>
                            <path
                                d="m16.6976 7.49975c.7654.4419.7694 1.1516.009 1.5935-.7542.4383-1.9858.4419-2.7511.0001-.7593-.4384-.7632-1.1553-.009-1.5936.7604-.4419 1.9918-.4384 2.7511 0z"
                                fill="#46a046"
                            />
                        </g>
                        <g>
                            <path
                                d="m29.9871 16.49025-.9637.5601c.857.7585.8624 1.684-.0897 2.2372l-1.2354-.7132c.431-.2505.2176-.8106-.4634-1.2038-.6749-.3897-1.6487-.515-2.0797-.2645s-.2116.8141.4634 1.2038c1.386.8002 1.5968 1.9763.4713 2.6304-.9459.5497-2.5497.5532-3.856.0557l-.9699.5636-1.2354-.7132.9699-.5637c-.8632-.755-.8684-1.6875.0775-2.2372l1.2354.7133c-.4311.2505-.2116.8141.4634 1.2038.6809.3931 1.6486.5149 2.0797.2644.431-.2505.2176-.8106-.4634-1.2037-1.38-.7968-1.591-1.9798-.4713-2.6304.9521-.5533 2.5557-.5498 3.8682-.0558l.9637-.5601z"
                                fill="#46a046"
                            />
                        </g>
                        <g>
                            <path
                                d="m8.4413 12.29785c.7653.4418.7693 1.1516.0092 1.5933-.7545.4385-1.9799.4385-2.7452-.0034-.7593-.4383-.7694-1.1516-.0148-1.5901.7601-.4417 1.9915-.4382 2.7508.0002z"
                                fill="#46a046"
                            />
                        </g>
                        <g>
                            <path
                                d="m44.3102 23.44185c.7654.4419.7694 1.1517.009 1.5936-.7543.4383-1.9858.4419-2.7511 0-.7593-.4384-.7572-1.1518-.003-1.5901.7605-.4419 1.9858-.4419 2.7451-.0035z"
                                fill="#46a046"
                            />
                        </g>
                        <g>
                            <path
                                d="m36.0539 28.23995c.7653.4419.7693 1.1516.0092 1.5933-.7545.4386-1.9799.4385-2.7452-.0033-.7593-.4384-.7634-1.1482-.0088-1.5867.7601-.4417 1.9854-.4417 2.7448-.0033z"
                                fill="#46a046"
                            />
                        </g>
                        <g>
                            <path
                                d="m15.3202 6.09405 31.4272 18.1446-12.0461 7.0004-12.9445-7.4735-18.4827-10.671zm3.7006 16.05c3.3265 1.9206 8.7145 1.9171 12.0134 0s3.2874-5.0381-.0391-6.9587c-3.3206-1.9171-8.7146-1.917-12.0135.0001s-3.2814 5.0415.0392 6.9586m-10.1546-8.0197 6.8157 3.9072c.2215-1.176 1.1042-2.3172 2.6549-3.2184s3.5119-1.4126 5.5475-1.5483l-6.7916-3.9212c1.0056-.5844 1.0006-1.51.0123-2.0806-.9823-.5672-2.5863-.5705-3.5683.0001-.9819.5707-.9647 1.4962.0176 2.0633l-4.6756 2.752c-1.0124-.5845-2.6164-.5878-3.5922-.0208-.9877.574-.9705 1.4995.0118 2.0667.9883.5706 2.5801.574 3.5679 0m27.595 13.8789 4.6816-2.7486c1.0124.5845 2.6042.588 3.5861.0174.982-.5707.977-1.4963-.0114-2.0669-.9822-.5671-2.5802-.567-3.5622.0036l-6.8153-3.9074c-.2338 1.1761-1.1103 2.3138-2.661 3.215-1.5507.9011-3.518 1.4161-5.5415 1.5518l6.7917 3.9211c-1.0118.5881-1.0006 1.5101-.0183 2.0772.9883.5706 2.5801.5741 3.5679 0 .9757-.567.9707-1.4926-.0176-2.0632m-16.7862-18.7221-.892.5184 3.6399 2.1014.8919-.5183zm17.9162 10.3439-.892.5184 3.6339 2.098.892-.5183zm-25.1609-1.917.8861-.515-3.6398-2.1015-.8862.515zm17.9102 10.3405.8862-.515-3.6339-2.098-.8861.5149z"
                                fill="#46a046"
                            />
                        </g>
                    </g>
                    <g>
                        <g enableBackground="new">
                            <g>
                                <path
                                    d="m35.7416 16.58735-14.2916 8.3053-.658-.3799 14.2916-8.3054z"
                                    fill="#86aedc"
                                />
                            </g>
                            <g>
                                <path
                                    d="m39.5801 18.80345-14.2916 8.3054-3.8385-2.2162 14.2916-8.3053z"
                                    fill="#e3e6f0"
                                />
                            </g>
                            <g>
                                <path
                                    d="m40.2342 19.18105-14.2916 8.3054-.6541-.3776 14.2916-8.3054z"
                                    fill="#86aedc"
                                />
                            </g>
                        </g>
                    </g>
                    <g>
                        <g enableBackground="new">
                            <g>
                                <path
                                    d="m21.4496 24.89245-.0299 4.5611-.6577-.3797.03-4.5611z"
                                    fill="#678cc8"
                                />
                            </g>
                            <g>
                                <path
                                    d="m25.285 27.10675-.03 4.5611-3.8353-2.2143.0299-4.5611z"
                                    fill="#d4dbe9"
                                />
                            </g>
                            <g>
                                <path
                                    d="m25.9426 27.48645-.0299 4.5611-.6577-.3797.03-4.5611z"
                                    fill="#678cc8"
                                />
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    )
}